<!-- 入库任务单 -->
<template>
    <div >
        <!-- 按钮组 -->
        <div class="buttons_box">
            <!-- <el-button type="primary" size="mini" class="mini_button">导入</el-button> -->
            <el-button type="primary" size="mini" class="mini_button" @click="warehousingSave">保存</el-button>
            <el-button type="primary" size="mini" class="mini_button" @click="warehousingDel" :disabled="warehousingForm.id ==='' || editConfig">删除</el-button>
            <el-button type="primary" size="mini" class="mini_button" @click="completeTask" v-if="!editConfig">任务结束</el-button>
            <el-button type="primary" size="mini" class="mini_button" @click="revokeCompleteTask" v-else>撤销结束</el-button>
            <el-button type="primary" size="mini" class="mini_button" @click="report('入库单')" >打印入库单</el-button>
            <el-dropdown trigger="click" @command="(command) => report(command)" style="margin: -2px 5px 0px 5px;">
                <span class="el-dropdown-link">
                    <el-button type="primary" size="mini" class="mini_button" >打印汇总货卡</el-button>
                </span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="汇总存货卡_有标识">存货卡_有标识</el-dropdown-item>
                    <el-dropdown-item command="汇总存货卡_无标识">存货卡_无标识</el-dropdown-item>
                    <el-dropdown-item command="汇总存货卡_建发">存货卡_建发</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
            <el-button type="primary" size="mini" class="mini_button" @click="report('存货凭证')" >打印保税仓库存货凭证</el-button>
            <el-button type="primary" size="mini" class="mini_button" @click="IMGListExport" >图片打包导出</el-button>
            <!-- <el-button type="primary" size="mini" class="mini_button" @click="downloadLOTFile" >下载LOT号模板</el-button> -->
            <!--<el-button type="primary" size="mini" class="mini_button">车辆报备</el-button> -->
        </div>
        <!-- 表头 -->
            <el-form class="demo-form-inline warehousingForm" :inline="true" ref="warehousingForm" :model="warehousingForm" :rules="warehousingFormRules"
             size="mini" label-width="160px">
                <el-divider content-position="left">任务信息</el-divider>
                <el-form-item label="任务状态" prop="billStatus"> 
                    <el-input disabled v-model="warehousingForm.billStatus" suffix-icon="xxxx" ></el-input>
                </el-form-item>
                <el-form-item label="入库单号" prop="billNo"> 
                    <el-input disabled v-model="warehousingForm.billNo" suffix-icon="xxxx" ></el-input>
                </el-form-item>
                <el-form-item label="作业状态" prop="taskStatus"> 
                    <el-input disabled placeholder="" v-model="warehousingForm.taskStatus"  suffix-icon="xxxx"></el-input>
                </el-form-item>
                <el-form-item label="单证员" prop="createUser"> 
                    <el-input disabled v-model="warehousingForm.createUser"  suffix-icon="xxxx" ></el-input>
                </el-form-item> 
                <el-form-item label="创建日期" prop="createDate"> 
                    <el-date-picker disabled v-model="warehousingForm.createDate" type="date" value-format="yyyy-MM-dd"  placeholder="" style="width:100%"> </el-date-picker>
                </el-form-item>
                <el-form-item label="计划作业日期" prop="planDate"> 
                    <el-date-picker v-model="warehousingForm.planDate" type="date" value-format="yyyy-MM-dd"  placeholder="" style="width:100%"
                    :disabled="editConfig" > </el-date-picker>
                </el-form-item>       
                <el-form-item label="备注" prop="remark"> 
                    <el-input :disabled="editConfig" placeholder="请输入备注" v-model="warehousingForm.remark" suffix-icon="xxxx" style="width: 550px;"></el-input>
                </el-form-item>         
                <el-divider content-position="left">货物信息</el-divider>
                <el-form-item label="提单号" prop="blNo"> 
                    <el-input placeholder="请输入提单号" v-model="warehousingForm.blNo" suffix-icon="xxxx" 
                    :disabled="editConfig"></el-input>
                </el-form-item>
                <el-form-item label="保税类型" prop="isBonded"> 
                    <el-select placeholder="请选择保税类型" v-model="warehousingForm.isBonded" @change="changeIsBonded"
                    :disabled="editConfig">
                        <el-option v-for="item in bondedTypeList" :key="item.value" :label="item.value" :value="item.value"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="仓库" prop="ckName"> 
                    <el-select  placeholder="请选择仓库" v-model="warehousingForm.ckName" @change="changeCkName" filterable
                    :disabled="editConfig">
                        <el-option v-for="item in ckNameList" :key="item" :label="item" :value="item"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="账册编号" :prop="(warehousingForm.isBonded === '非保税' || warehousingForm.ckName === '外协库' )?'':'handbook'" > 
                    <el-select placeholder="请选择账册编号" v-model="warehousingForm.handbook" :disabled="editConfig">
                        <el-option v-for="item in handBookNoList" :key="item.bookNo" :label="item.bookNo" :value="item.bookNo"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="报关单号" :prop="warehousingForm.isBonded === '保税'?'cusDeclNo':''" > 
                    <el-input placeholder="请输入报关单号" v-model="warehousingForm.cusDeclNo" suffix-icon="xxxx" :disabled="warehousingForm.isBonded === '非保税' || editConfig"></el-input>
                </el-form-item>                    
                <el-form-item label="核注清单号" prop="invDecNo" :prop="warehousingForm.isBonded === '保税'?'invDecNo':''" > 
                    <el-input placeholder="请输入核注清单号" v-model="warehousingForm.invDecNo" suffix-icon="xxxx" :disabled="warehousingForm.isBonded === '非保税' || editConfig"></el-input>
                </el-form-item>
                <!-- <el-form-item label="备案清单号" :prop="warehousingForm.isBonded === '保税'?'cusDeclNo':''" > 
                    <el-input :disabled="editConfig" placeholder="请输入备案清单号" v-model="warehousingForm.invDecNo" suffix-icon="xxxx"></el-input>
                </el-form-item> -->
                <el-form-item label="委托单位" prop="customer" > 
                    <el-select filterable placeholder="请选择委托单位" v-model="warehousingForm.customer" @change="changeCustomer" :disabled="editConfig">
                        <el-option v-for="item in customerList" :key="item.id" :label="item.companyName" :value="item.companyName"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="货主单位" prop="ownerName"> 
                    <el-select filterable placeholder="请选择货主单位" v-model="warehousingForm.ownerName" :disabled="editConfig">
                        <el-option v-for="item in customerList" :key="item.id" :label="item.companyName" :value="item.companyName"> </el-option>
                    </el-select>
                </el-form-item>
                
                <el-form-item label="箱型" prop="boxType"> 
                    <el-select placeholder="请选择箱型" v-model="warehousingForm.boxType" :disabled="editConfig">
                        <el-option v-for="item in boxTypeList" :key="item.value" :label="item.value" :value="item.value"> </el-option>
                    </el-select> 
                </el-form-item>
                <el-form-item label="箱量"> 
                    <el-input :disabled="editConfig" placeholder="请输入箱量" suffix-icon="xxxx"></el-input>
                </el-form-item>
                <el-form-item label="净重(总)" prop="netWeight"> 
                    <el-input disabled v-model="warehousingForm.netWeight" suffix-icon="xxxx" ></el-input>
                </el-form-item>
                <el-form-item label="件数1(总)" prop="qty1Sum"> 
                    <el-input disabled v-model="warehousingForm.qty1Sum" suffix-icon="xxxx" ></el-input>
                </el-form-item>
                <el-form-item label="件数2(总)" prop="qty2Sum"> 
                    <el-input  v-model="warehousingForm.qty2Sum" suffix-icon="xxxx" disabled></el-input>
                </el-form-item>
                 <el-form-item label="毛重(总)" prop="grossWeight"> 
                    <el-input :disabled="editConfig" placeholder="请输入毛重" v-model="warehousingForm.grossWeight" suffix-icon="xxxx" ></el-input>
                </el-form-item>
                <el-form-item label="体积(总)" prop="volume"> 
                    <el-input :disabled="editConfig" placeholder="请输入体积(总)" v-model="warehousingForm.volume" suffix-icon="xxxx" ></el-input>
                </el-form-item>
                <el-form-item label="过磅" prop="scaleNum"> 
                    <el-input :disabled="editConfig" placeholder="请输入过磅" v-model="warehousingForm.scaleNum" suffix-icon="xxxx" ></el-input>
                </el-form-item>
                <el-form-item label="工作量" prop="workNum" > 
                    <el-input disabled placeholder="" v-model="warehousingForm.workNum" suffix-icon="xxxx"></el-input>
                </el-form-item>
                <el-form-item label="箱号" prop="boxNo" > 
                    <el-input disabled placeholder="" v-model="warehousingForm.boxNo" suffix-icon="xxxx"></el-input>
                </el-form-item>
                <el-form-item label="货物名称" prop="goodsDes" > 
                    <el-input disabled placeholder="" v-model="warehousingForm.goodsDes" suffix-icon="xxxx" style="width: 550px;"></el-input>
                </el-form-item>            
                
            </el-form>
            <!-- 表体 -->
            <el-divider content-position="left">计划信息</el-divider>
            <div class="buttons_box" style="justify-content: space-between;">
                <div>
                    <el-button type="primary" size="mini" class="mini_button" @click="addRows" :disabled="warehousingForm.id ==='' || editConfig " >新增</el-button>
                    <el-button type="primary" size="mini" class="mini_button" @click="copyRows" :disabled="editConfig ">复制</el-button>
                    <!-- <el-button type="primary" size="mini" class="mini_button" @click="copyRowsLH" :disabled="editConfig || inWarehouseDataRowStatus">复制硫磺</el-button> -->
                    <el-button type="primary" size="mini" class="mini_button" @click="copyRowsXH" :disabled="editConfig ">复制箱号/铅封号</el-button>
                    <el-button type="primary" size="mini" class="mini_button" @click="exitRows" :disabled="editConfig ">编辑</el-button>
                    <el-button type="success" size="mini" class="mini_button" @click="delRows" :disabled="editConfig ">删除</el-button>
                    <!-- <el-button type="primary" size="mini" class="mini_button" @click="getIssueAll">查询全部下发任务</el-button> -->
                    <el-button type="success" size="mini" class="mini_button" @click="IssueRowsSave" :disabled="editConfig">下发暂存</el-button>
                    <el-button type="success" size="mini" class="mini_button" @click="fillItemNoAll" :disabled="editConfig">批量填充项号</el-button>
                </div>
                <vxe-toolbar ref="toolbarRef"  custom ></vxe-toolbar>
            </div>
            <!-- 计划信息列表 -->
            <vxe-table id="inWarehouseTable"  size="mini" ref="inWarehouseTable" :data="inWarehouseData" :columns="inWarehouseColumns" border stripe
            :column-config="{resizable: true,sortable: true,drag:true}"  header-align="center" :custom-config="inWarehouseCustomConfig" 
            :row-config="{ isCurrent: true,isHover: true}"  :checkbox-config="{labelField: '', highlight: true}"  @checkbox-change="inWarehouseRowsCheckbox"
            max-height="250" @cell-click="inWarehouseRowsChange" @checkbox-all="inWarehouseRowsCheckbox">
                <!-- 列渲染 -->
                <vxe-column type="checkbox" fixed="left" width="50"></vxe-column>
                <vxe-column type="seq" width="50" fixed="left"></vxe-column>
                <vxe-column v-for="column in inWarehouseColumns" :field="column.field" :title="column.title" sortable  >
                    <!--  :filters="column.field" -->
                     <template #default="{ row, column }">

                        <span v-if="column.field === 'decCurrency'"> 
                            {{ row.decCurrencyName }}
                        </span>
                        <span v-else-if="column.field === 'qty1Unit'"> 
                            {{ row.qty1UnitName }}
                        </span>
                        <span v-else-if="column.field === 'qty2Unit'"> 
                            {{ row.qty2UnitName }}
                        </span>
                        <span v-else-if="column.field === 'originCountry'"> 
                            {{ row.originCountryName }}
                        </span>
                        <span v-else-if="column.field === 'lawUnitFirst'"> 
                            {{ row.lawUnitFirstName }}
                        </span>
                        <span v-else-if="column.field === 'lawUnitSecond'"> 
                            {{ row. lawUnitSecondName }}
                        </span>
                        <span v-else-if="column.field === 'decUnit'"> 
                            {{ row. decUnitName }}
                        </span>
                        <!-- boxNo -->
                        <span v-else> {{ row[column.field] }} </span>
                    </template>
                </vxe-column>
            </vxe-table>
            <!-- 下发任务列表 -->
            <el-divider content-position="left" >作业信息</el-divider>
            <el-tabs style="margin: 0px 10px;" v-model="IssueGoodsTabs" @tab-click="switchIssueGoods">
                <el-tab-pane label="作业详情" name="first">
                    <vxe-table id="IssueGoodsTable"  size="mini" ref="IssueGoodsTable" :data="IssueGoodsData" border stripe
                        :column-config="{resizable: true,sortable: true}"  header-align="center" :row-config="{ isHover: true}" 
                        :radio-config="{labelField: '', highlight: true}" style="margin-top: 0px;" min-height="0"  max-height="400" 
                        :expand-config="IssueGoodsRowExpandShow">
                            <vxe-column type="seq" width="50" ></vxe-column>
                            <vxe-column type="expand" width="30" >
                                <template #content="{ row }">
                                    <div class="expand-wrapper">
                                        <vxe-table border :data="row.childList" header-align="center" max-height="200" min-height="50" style="margin: 10px !important;"
                                        :column-config="{resizable: true,sortable: true}">
                                            <vxe-column type="seq" width="50"></vxe-column>
                                            <vxe-column field="goodsName" title="货物名称" min-width="180" >
                                                <template #default="{ row: childRow, $rowIndex }" >
                                                    <span>{{ childRow.goodsName }}</span> 
                                                    <span v-if="childRow.lotNo">- {{ childRow.lotNo }} - {{ childRow.lotKgs }}</span>
                                                    <span v-if="childRow.lotNo" style="display: flex;flex-direction: column;">
                                                        <span>订单号:{{ childRow.lotOrderNo }} </span>
                                                        <span>物料号:{{ childRow.lotMaterialNo }}</span>
                                                    </span>
                                                    <span v-else></span>
                                                </template>
                                            </vxe-column>
                                            <vxe-column field="spec" title="规格型号"  ></vxe-column>
                                            <vxe-column field="planPlace" title="库区库位">
                                                <template #default="{ row: childRow, $rowIndex }">
                                                    {{childRow.place}} - {{childRow.location}}
                                                </template>
                                            </vxe-column>
                                            <vxe-column field="itemNo" title="项号" ></vxe-column>
                                            <vxe-column field="qty1" title="件数1"></vxe-column>
                                            <vxe-column field="qty1Unit" title="件数1单位" width="85">
                                                <template #default="{ row: childRow, $rowIndex }">
                                                    {{findNameByCode(childRow.qty1Unit, unitList)}}
                                                </template>
                                            </vxe-column>
                                            <vxe-column field="qty2" title="件数2"></vxe-column>
                                            <vxe-column field="qty2Unit" title="件数2单位" width="85">
                                                <template #default="{ row: childRow, $rowIndex }">
                                                    {{findNameByCode(childRow.qty2Unit, unitList)}}
                                                </template>
                                            </vxe-column>
                                            <vxe-column field="netWeight" title="净重（KG）" ></vxe-column>
                                            <vxe-column field="decNum" title="申报数量" ></vxe-column>
                                            <vxe-column field="decAmount" title="申报金额" ></vxe-column>
                                            <vxe-column field="firstNum" title="法定第一数量" ></vxe-column>
                                            <vxe-column field="secondNum" title="法定第二数量" ></vxe-column>
                                            <vxe-column field="taskNote" title="作业备注" min-width="120"></vxe-column>
                                        </vxe-table>
                                    </div>
                                </template>
                            </vxe-column>
                            <vxe-column field="rowStatus" title="状态" sortable width="70"></vxe-column>
                            <vxe-column field="taskNo" title="作业任务单号" min-width="130">
                                <template #default="{ row } ">
                                    <span v-if="row.rowStatus === '完成'" @click="getCompleteDetails(row)">
                                        <el-link  type="primary"  style="font-size: 12px;">{{row.taskNo}}</el-link>
                                    </span>
                                    <span v-else> {{ row.taskNo }} </span>
                                </template>
                            </vxe-column>
                            <vxe-column field="blNo" title="提单号" min-width="125"></vxe-column>
                            <vxe-column field="storekeeper" title="理货员"  min-width="70"></vxe-column>
                            <vxe-column field="goodsName" title="货物名称"  min-width="100"></vxe-column>
                            <!-- <vxe-column field="spec" title="规格型号"  min-width="100"></vxe-column> -->
                            <vxe-column field="ckName" title="仓库" min-width="90"></vxe-column>
                            <vxe-column field="driver" title="司机" min-width="60"></vxe-column>
                            <vxe-column field="truckNo" title="车牌" min-width="80"></vxe-column>
                            <vxe-column field="qty1" title="总件数1" min-width="80"></vxe-column>
                            <vxe-column field="netWeight" title="总净重(KG)" min-width="90"></vxe-column>
                            <!-- <vxe-column field="itemNo" title="项号" min-width="50"></vxe-column> -->
                            <vxe-column field="boxNo" title="箱号" min-width="120">
                            </vxe-column>
                            <vxe-column field="sealNo" title="铅封号" min-width="120"></vxe-column>
                            <vxe-column field="note" title="备注" min-width="120"></vxe-column>
                            <vxe-column field="opNote" title="现场反馈" min-width="120"></vxe-column>
                            <vxe-column field="createTime" title="创建时间" sortable  width="130"  :formatter="({ cellValue }) => cellValue ? cellValue.split('T')[0] + '  ' +  cellValue.split('T')[1] : ''" ></vxe-column>
                            <vxe-column field="completeDate" title="入库日期" sortable  width="130" ></vxe-column>
                            <vxe-column title="操作" fixed="right" width="200">
                                <template #default="{ row }">
                                    <!-- <el-button  type="text"  size="mini" class="mini_button_text" @click="exitIssueGoodsRows(row)"  :disabled="editConfig">编辑</el-button> -->
                                    <el-button type="text" :disabled=" row.rowStatus !== '暂存'  || editConfig" size="mini" class="mini_button_text" @click="exitIssueRows(row)">编辑</el-button>
                                    <el-button type="text" :disabled="( row.rowStatus !== '完成' ? false : true) || editConfig" size="mini" class="mini_button_text" @click="delIssueRows(row)">删除</el-button>
                                    <el-button type="text" :disabled="( row.rowStatus !== '暂存' ) || editConfig" size="mini" class="mini_button_text" @click="IssueRows(row)">下发</el-button>
                                    <el-button type="text" :disabled="( row.rowStatus === '已下发' ? false : true) || editConfig"  size="mini" class="mini_button_text" @click="completeRows(row)">完成</el-button>
                                    <el-dropdown trigger="click" @command="(command) => report(command, row)">
                                        <span class="el-dropdown-link">
                                            <el-button type="text" size="mini" class="mini_button_text" >打印</el-button>
                                        </span>
                                        <el-dropdown-menu slot="dropdown">
                                            <el-dropdown-item command="入库受理单">入库受理单</el-dropdown-item>
                                            <el-dropdown-item command="存货卡_有标识">存货卡_有标识</el-dropdown-item>
                                            <el-dropdown-item command="存货卡_无标识">存货卡_无标识</el-dropdown-item>
                                            <el-dropdown-item command="存货卡_建发">存货卡_建发</el-dropdown-item>
                                        </el-dropdown-menu>
                                    </el-dropdown>
                                </template>
                            </vxe-column>
                        </vxe-table>
                </el-tab-pane>
                <el-tab-pane label="入库详情" name="second">
                    <vxe-table id="IssueGoodsTableAllJob"  size="mini" ref="IssueGoodsTableAllJob" :data="IssueGoodsAllJob" border stripe
                        :column-config="{resizable: true,sortable: true}"  header-align="center" :row-config="{ isHover: true}" 
                        :radio-config="{labelField: '', highlight: true}" style="margin-top: 0px;" min-height="250"  max-height="400" >
                            <vxe-column type="seq" width="50" fixed="left"></vxe-column>
                            <!-- <vxe-column field="rowStatus" title="状态" sortable width="70"></vxe-column>
                            <vxe-column field="taskNo" title="作业任务单号" width="130"></vxe-column> -->
                            <vxe-column field="blNo" title="提单号" width="120"></vxe-column>
                            <vxe-column field="storekeeper" title="理货员"  width="100"></vxe-column>
                            <vxe-column field="goodsName" title="货物名称"  width="100"></vxe-column>
                            <vxe-column field="spec" title="规格型号"  width="100"></vxe-column>
                            <vxe-column field="ckName" title="仓库" width="90"></vxe-column>
                            <vxe-column field="place" title="库区"></vxe-column>
                            <vxe-column field="location" title="库位"></vxe-column>
                            <vxe-column field="driver" title="司机"></vxe-column>
                            <vxe-column field="truckNo" title="车牌"></vxe-column>
                            <vxe-colgroup title="任务数量">
                                <vxe-column field="netWeight" title="净重（KG）"  width="85"></vxe-column>
                                <vxe-column field="qty1" title="件数1"></vxe-column>
                                <vxe-column field="qty1Unit" title="件数1单位">
                                    <template #default="{ row }">
                                        {{findNameByCode(row.qty1Unit, unitList)}}
                                    </template>
                                </vxe-column>
                                <vxe-column field="qty2" title="件数2"></vxe-column>
                                <vxe-column field="qty2Unit" title="件数2单位">
                                    <template #default="{ row }">
                                        {{findNameByCode(row.qty2Unit, unitList)}}
                                    </template>
                                </vxe-column>
                            </vxe-colgroup>
                            <vxe-column field="itemNo" title="项号"></vxe-column>
                            <vxe-column field="boxNo" title="箱号"></vxe-column>
                            <vxe-column field="sealNo" title="铅封号"></vxe-column>
                            <vxe-column field="completeDate" title="创建时间" sortable  width="130"  ></vxe-column>
                            <!-- <vxe-column field="completeTime" title="入库时间" sortable  width="130"  :formatter="({ cellValue }) => cellValue ? cellValue.split('T')[0] + '  ' +  cellValue.split('T')[1] : ''" ></vxe-column> -->
                        </vxe-table>
                </el-tab-pane>
            </el-tabs>
            <div style="width: 100%;height: 200px;"></div>

            <!-- 新增货物信息弹窗 -->
            <el-dialog title="新增货物信息" width="95%" :visible.sync="addGoodsVisible" :before-close="addGoodsClose" v-dialogDrag
             :close-on-click-modal="false" >
                <el-form :model="addGoodsForm" ref="addGoodsForm" class="demo-form-inline goods_form" size="mini" label-width="100px"
                :rules="inWarehouseRules" v-if="addGoodsVisible">
                    <el-row>
                        <el-col :span="4">
                            <el-form-item label="作业状态" >
                                <el-input disabled v-model="addGoodsForm.rowStatus" placeholder=""></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="作业单号" prop="">
                                <el-input disabled v-model="addGoodsForm.mobileNo" placeholder=""></el-input>
                            </el-form-item>
                        </el-col>
                         <el-col :span="5">
                            <el-form-item label="司机" prop="driver">
                                <el-input v-model="addGoodsForm.driver" placeholder="请输入司机"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="车牌" prop="truckNo">
                                <!-- <el-input v-model="addGoodsForm.truckNo" placeholder="请输入车牌"></el-input> -->
                                <el-select class="width_100" v-model="addGoodsForm.truckNo" placeholder="请选择或输入车牌" filterable remote @focus="driverTruckNoList=[]"
                                :remote-method="truckNoRemoteMethod" @change="truckNoHandleChange($event,'addGoodsForm')" @blur="selectTruckNo($event,'addGoodsForm')" :default-first-option="true" >
                                    <el-option v-for="item in driverTruckNoList" :key="item.id" :label="item.carNo" :value="item.carNo + '-' + item.driver " >
                                        <span>{{ item.carNo }} - {{ item.driver }} </span>
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                         <el-col :span="5">
                            <el-form-item label="包装" prop="packageType">
                                <el-input :disabled="!addGoodsExit" clearable v-model="addGoodsForm.packageType" placeholder="请输入包装"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="4">
                            <el-form-item label="货物名称" prop="goodsName">
                                <el-select :disabled="!addGoodsExit" class="width_100" filterable :default-first-option="true" 
                                remote :remote-method="getGoodsList" placeholder="请选择货物名称" 
                                v-model="addGoodsForm.goodsName" clearable @change="goodsEnter($event)">
                                    <el-option v-for="item in goodsList" :key="item.id" :label="item.goodsName" :value="item.goodsName + '-' + item.goodsType + '-' + item.hsCode ">
                                        <span class="margin_right_20">{{ item.goodsName }}</span>
                                        <span class="margin_right_20">{{ item.goodsType }}</span> 
                                        <span >{{ item.hsCode }}</span> 
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="货物分类" prop="goodsType">
                                <el-input disabled v-model="addGoodsForm.goodsType" placeholder=""></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="海关编码" prop="hsCode">
                                <el-input disabled v-model="addGoodsForm.hsCode" placeholder=""></el-input>
                            </el-form-item>
                        </el-col>
                       <el-col :span="5">
                            <el-form-item label="箱号" prop="boxNo">
                                <el-input v-model="addGoodsForm.boxNo" placeholder="请输入箱号"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="铅封号" prop="sealNo">
                                <el-input v-model="addGoodsForm.sealNo" placeholder="请输入铅封号"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="4">
                            <el-form-item label="商品料号" prop="skuNo">
                                <el-input :disabled="!addGoodsExit" clearable v-model="addGoodsForm.skuNo" placeholder="请输入商品料号"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="10">
                            <el-form-item label="规格型号" prop="spec">
                                <el-input :disabled="!addGoodsExit" v-model="addGoodsForm.spec" placeholder="请输入规格型号"></el-input>
                            </el-form-item>
                        </el-col>
                         <el-col :span="5">
                            <el-form-item label="币制" :prop="warehousingForm.isBonded === '保税' ? 'decCurrency':'' ">
                                <el-select :disabled="!addGoodsExit" clearable class="width_100" filterable :default-first-option="true" 
                                placeholder="请选择币制" v-model="addGoodsForm.decCurrency">
                                    <el-option v-for="item in currencyList" :key="item.codeValue" :label="item.codeValue + ' - ' + item.codeName + ' - ' + item.cusCode" :value="item.codeValue">
                                        <span class="margin_right_20">{{ item.codeValue }}</span>
                                        <span class="margin_right_20">{{ item.codeName }}</span> 
                                        <span >{{ item.cusCode }}</span> 
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="原产地" prop="originCountry">
                                <el-select :disabled="!addGoodsExit" clearable class="width_100" filterable remote :remote-method="getCountryList" 
                                placeholder="请选择原产地" v-model="addGoodsForm.originCountry" :default-first-option="true">
                                        <el-option v-for="item in countryList" :key="item.codeValue" :label="item.codeValue + ' - ' + item.codeName + ' - ' + item.cusCode" :value="item.codeValue">
                                            <span class="margin_right_20">{{ item.codeValue }}</span>
                                            <span class="margin_right_20">{{ item.codeName }}</span> 
                                            <span >{{ item.cusCode }}</span>  
                                        </el-option>
                                    </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                        <!-- <el-col :span="6">
                            <el-form-item label="项号" prop="itemNo">
                                <el-input clearable v-model="addGoodsForm.itemNo" placeholder="请输入项号"></el-input>
                            </el-form-item>
                        </el-col> -->
                    <el-row>
                        <el-col :span="4">
                            <el-form-item label="净重(KG)" prop="netWeight">
                                <el-input :disabled="!addGoodsExit" clearable v-model="addGoodsForm.netWeight" placeholder="请输入净重"
                                onkeyup="value=value.match(/\d+\.?\d{0,4}/,'')"  @blur="blurNetWeight"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="件数1" prop="qty1">
                                <el-input :disabled="!addGoodsExit" clearable v-model="addGoodsForm.qty1" placeholder="请输入件数"
                                onkeyup="value=value.match(/\d+\.?\d{0,4}/,'')"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="件数1单位" prop="qty1Unit"> 
                                <el-select :disabled="!addGoodsExit" class="width_100" filterable clearable  :filter-method="customFilter"
                                :default-first-option="true" v-model="addGoodsForm.qty1Unit" placeholder="请选择件数1单位" >
                                    <el-option v-for="item in unitList"  :key="item.codeValue" :label="item.codeName " :value="item.codeValue">
                                        <span class="margin_right_20">{{ item.codeValue }}</span>
                                        <span >{{ item.codeName }}</span> 
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="件数2" prop="qty2">
                                <el-input :disabled="!addGoodsExit" clearable v-model="addGoodsForm.qty2" placeholder="请输入件数"
                                onkeyup="value=value.match(/\d+\.?\d{0,4}/,'')"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="件数2单位" prop="qty2Unit"> 
                                <el-select :disabled="!addGoodsExit" class="width_100" filterable clearable :filter-method="customFilter"
                                :default-first-option="true" v-model="addGoodsForm.qty2Unit" placeholder="请选择件数2单位" >
                                    <el-option v-for="item in unitList"  :key="item.codeValue" :label="item.codeName " :value="item.codeValue">
                                        <span class="margin_right_20">{{ item.codeValue }}</span>
                                        <span >{{ item.codeName }}</span> 
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                         <el-col :span="4">
                            <el-form-item label="单价" :prop="warehousingForm.isBonded === '保税' ?'decPrice':''">
                                <el-input :disabled="!addGoodsExit" clearable v-model="addGoodsForm.decPrice" @blur="blurDecPrice"
                                onkeyup="value=value.match(/\d+\.?\d{0,4}/,'')" placeholder="请输入单价"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="申报金额" :prop="warehousingForm.isBonded === '保税' ?'decAmount':''">
                                <el-input :disabled="!addGoodsExit" clearable v-model="addGoodsForm.decAmount" 
                                onkeyup="value=value.match(/\d+\.?\d{0,4}/,'')" placeholder="请输入申报金额（总价）"></el-input>
                            </el-form-item>
                        </el-col>
                         <el-col :span="5">
                            <el-form-item label="申报数量" :prop="warehousingForm.isBonded === '保税' ?'decNum':'' ">
                                <el-input :disabled="!addGoodsExit" clearable v-model="addGoodsForm.decNum" placeholder="请输入申报数量"
                                onkeyup="value=value.match(/\d+\.?\d{0,4}/,'')"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="申报单位" :prop="warehousingForm.isBonded === '保税' ?'decUnit':'' ">
                                <el-select :disabled="!addGoodsExit" clearable class="width_100" filterable :default-first-option="true" 
                                v-model="addGoodsForm.decUnit" placeholder="请选择申报单位" :filter-method="customFilter" >
                                    <el-option v-for="item in unitList"  :key="item.codeValue" :label="item.codeName " :value="item.codeValue">
                                        <span class="margin_right_20">{{ item.codeValue }}</span>
                                        <span >{{ item.codeName }}</span> 
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="体积(m³)" prop="vol">
                                <el-input :disabled="!addGoodsExit" clearable v-model="addGoodsForm.vol" placeholder="请输入体积"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="4">
                            <el-form-item label="法一数量" :prop="addGoodsForm.lawUnitFirst ? 'firstNum':'' " >
                                <el-input :disabled="!addGoodsForm.lawUnitFirst || !addGoodsExit" clearable v-model="addGoodsForm.firstNum" 
                                onkeyup="value=value.match(/\d+\.?\d{0,4}/,'')" placeholder="请输入法定第一数量" ></el-input>                            
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="法一单位" prop="lawUnitFirst">
                                <el-select disabled class="width_100" filterable  :filter-method="customFilter"
                                :default-first-option="true" v-model="addGoodsForm.lawUnitFirst" placeholder="请选择法定第一计量单位" >
                                    <el-option v-for="item in unitList"  :key="item.codeValue" :label="item.codeName " :value="item.codeValue">
                                        <span class="margin_right_20">{{ item.codeValue }}</span>
                                        <span >{{ item.codeName }}</span> 
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="法二数量" prop="secondNum">
                                <el-input clearable v-model="addGoodsForm.secondNum" :disabled="!addGoodsForm.lawUnitSecond || addGoodsExit"
                                onkeyup="value=value.match(/\d+\.?\d{0,4}/,'')" placeholder="请输入法定第二数量" ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="法二单位" prop="lawUnitSecond">
                                <el-select disabled class="width_100" filterable :filter-method="customFilter"
                                :default-first-option="true" v-model="addGoodsForm.lawUnitSecond" placeholder="请选择法定第二计量单位" >
                                    <el-option v-for="item in unitList"  :key="item.codeValue" :label="item.codeName " :value="item.codeValue">
                                        <span class="margin_right_20">{{ item.codeValue }}</span>
                                        <span >{{ item.codeName }}</span> 
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>                    
                        <el-col :span="5">
                            <el-form-item label="作业备注" prop="taskNote">
                                <el-input :disabled="!addGoodsExit" v-model="addGoodsForm.taskNote" placeholder="请输入作业备注"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <!-- 如果是硫磺的话则填写订单号和物料号 -->
                    <el-row v-if="addGoodsForm.goodsName?.includes('硫磺')">
                        <el-col :span="4">
                            <el-form-item label="LOT订单号" :prop="addGoodsForm.goodsName?.includes('硫磺')  ? 'lotOrderNo':''">
                                <el-input :disabled="!addGoodsExit" clearable v-model="addGoodsForm.lotOrderNo" 
                                placeholder="请输入LOT订单号"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="LOT物料号" :prop="addGoodsForm.goodsName?.includes('硫磺')  ? 'lotMaterialNo':''">
                                <el-input :disabled="!addGoodsExit" clearable v-model="addGoodsForm.lotMaterialNo" 
                                placeholder="请输入LOT物料号"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button size="mini" @click="addGoodsClose">取 消</el-button>
                    <el-button size="mini" type="primary" @click="saveAddGoods">确 定</el-button>
                </span>
            </el-dialog>
            <!-- 批量复制硫磺 箱号/铅封号-->
            <el-dialog title="批量复制" width="40%" :visible.sync="copySulfurVisible" :before-close="copySulfurClose" v-dialogDrag
             :close-on-click-modal="false" >
             <el-checkbox v-model="copySulfurTextFlag">是否合并,合并请勾选</el-checkbox>
                <div  v-if="copySulfurType === '箱号/铅封号'" style="display: flex;margin-top: 10px;" >
                    <el-input type="textarea" :rows="20" placeholder="请输入箱号 " v-model="copySulfurTextXH"></el-input>
                    <el-input type="textarea" :rows="20" placeholder="请输入铅封号号 " v-model="copySulfurTextQFH"></el-input>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button size="mini" type="primary" @click="saveCopySulfur">确 定</el-button>
                </span>
            </el-dialog>
            <el-dialog title="任务下发" width="95%" :visible.sync="IssueGoodsVisible" :before-close="IssueGoodsClose" v-dialogDrag
             :close-on-click-modal="false" >
                <!-- 下发填写表单 -->
                <el-form :model="issueGoodsForm" ref="issueGoodsForm" class="demo-form-inline " size="mini" label-width="95px"
                :rules="issueGoodsFormRules" >
                    <el-row>
                        <el-col :span="4">
                             <el-form-item label="理货员" prop="storekeeper">
                                <el-select class="width_100"  v-model="issueGoodsForm.storekeeper" placeholder="请选择理货员" >
                                    <el-option v-for="item in storekeeperList"  :key="item.name" :label="item.name " :value="item.name">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="司机" prop="driver">
                                <el-input v-model="issueGoodsForm.driver" placeholder="请输入司机"></el-input>
                                
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="车牌" prop="truckNo">
                                <!-- <el-input v-model="issueGoodsForm.truckNo" placeholder="请输入车牌"></el-input> -->
                                <el-select class="width_100"  v-model="issueGoodsForm.truckNo" placeholder="请选择或输入车牌" filterable remote @focus="driverTruckNoList=[]"
                                :remote-method="truckNoRemoteMethod" @change="truckNoHandleChange($event,'issueGoodsForm')" @blur="selectTruckNo($event,'issueGoodsForm')" :default-first-option="true" >
                                    <el-option v-for="item in driverTruckNoList" :key="item.id" :label="item.carNo" :value="item.carNo + '-' + item.driver " >
                                        <span>{{ item.carNo }} - {{ item.driver }} </span>
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="箱号" prop="boxNo">
                                <el-input v-model="issueGoodsForm.boxNo" placeholder="请输入箱号"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="铅封号" prop="sealNo">
                                <el-input v-model="issueGoodsForm.sealNo" placeholder="请输入铅封号"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="9">
                            <el-form-item label="备注" prop="note">
                                <el-input v-model="issueGoodsForm.note" placeholder="请输入备注"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="LOT重量" prop="lotKgs" v-if="issueGoodsLOTColumn">
                                <el-input v-model="issueGoodsForm.lotKgs" onkeyup="value=value.match(/\d+\.?\d{0,4}/,'')" placeholder="请输入LOT重量"></el-input>
                            </el-form-item>
                        </el-col>
                         <el-col :span="5" >
                            <!-- :prop="issueGoodsLOTColumn ? 'lotMaterialNo':'' "  -->
                            <el-form-item label="LOT物料号" prop="issueGoodsLOTColumn" v-if="issueGoodsLOTColumn" >
                                <el-input v-model="issueGoodsForm.lotMaterialNo" placeholder="请输入LOT物料号"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5" >
                             <!-- :prop="issueGoodsLOTColumn ? 'lotOrderNo':'' "  -->
                            <el-form-item label="LOT订单号" prop="lotOrderNo" v-if="issueGoodsLOTColumn">
                                <el-input v-model="issueGoodsForm.lotOrderNo" placeholder="请输入LOT订单号"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <!-- 如果有硫磺则显示 -->
                    <el-row>
                        <el-col :span="9">
                             <!-- :prop="issueGoodsLOTColumn ? 'lotNo':'' "  -->
                            <el-form-item label="LOT号" prop="lotNo" v-if="issueGoodsLOTColumn">
                                <el-input type="textarea" :rows="10" v-model="issueGoodsForm.lotNo" placeholder="请输入LOT号"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
                <el-divider content-position="left">下发信息</el-divider>
                <!-- 货物列表 -->
                <vxe-table border size="mini" ref="finishIssueGoodsTable" :data="inWarehouseCheckboxExitRow" :row-config="{keyField: 'id'}" header-align="center"
                  max-height="350px">
                    <vxe-column field="goodsName" title="货物信息"  fixed="left" width="150">
                        <template #default="{ row, $rowIndex }" >
                            {{ row.goodsName }} - {{ row.spec }}
                        </template>
                    </vxe-column>
                    <vxe-column field="place" title="库区库位"  fixed="left" width="260">
                        <template #default="{ row, $rowIndex }" >
                            <span class="IssueGoodsExitRow_flex"> 
                                <el-select size="mini" @change="(value) => placeEnter(value, row, $rowIndex)" v-model="row.place" placeholder="请选择库区" filterable>
                                    <el-option v-for="item in placeList"  :key="item.name" :label="item.name " :value="item.name + '-' + item.id">
                                    </el-option>
                                </el-select>
                                <el-select size="mini" filterable v-model="row.location" placeholder="请选择库位" @change="(value) => locationEnter(value, row, $rowIndex)"
                                    @focus="locationRowFocus( row, $rowIndex)">
                                    <el-option v-for="item in locationList"  :key="item.locationName" :label="item.locationName " :value="item.locationName">
                                    </el-option>
                                </el-select>
                            </span>
                        </template>
                    </vxe-column>
                   <vxe-column field="qty1" title="件数1"  >
                        <template #default="{ row, $rowIndex }" >
                            <span class="IssueGoodsExitRow">
                                <el-input  v-model="row.qty1" placeholder="请输入件数1" size="mini"
                                    onkeyup="value=value.match(/^[1-9]\d*\.?\d{0,4}|0\.\d{1,4}/) || ''" @blur="IssueGoodsRowQty1Blur(row,$rowIndex)"></el-input>
                                <span class="IssueGoodsTipText">待/已下发：{{ inWarehouseCheckbox[$rowIndex].qty1 }} / {{  inWarehouseCheckbox[$rowIndex].workedQty1 }}</span>
                            </span>
                        </template>
                    </vxe-column>
                    <vxe-column field="qty2" title="件数2" >
                        <template #default="{ row, $rowIndex }">
                            <span class="IssueGoodsExitRow" >
                                <el-input v-model="row.qty2" :disabled="!inWarehouseCheckbox[$rowIndex].qty2" placeholder="请输入件数2" size="mini" onkeyup="value=value.match(/^[1-9]\d*\.?\d{0,4}|0\.\d{1,4}/) || ''"
                                ></el-input>
                                <span class="IssueGoodsTipText">待/已下发：{{ inWarehouseCheckbox[$rowIndex].qty2 }} / {{  inWarehouseCheckbox[$rowIndex].workedQty2 }}</span>
                            </span>
                        </template>
                    </vxe-column>
                    <vxe-column field="netWeight" title="净重（KG）" >
                        <template #default="{ row, $rowIndex }" >
                            <span class="IssueGoodsExitRow">
                                <el-input  v-model="row.netWeight" :disabled="!inWarehouseCheckbox[$rowIndex].netWeight" placeholder="请输入净重" size="mini" onkeyup="value=value.match(/^[1-9]\d*\.?\d{0,4}|0\.\d{1,4}/) || ''"
                                @blur="blurNetWeightIssueGoods(row, $rowIndex)"></el-input>
                                <span class="IssueGoodsTipText">待/已下发：{{ inWarehouseCheckbox[$rowIndex].netWeight }} / {{  inWarehouseCheckbox[$rowIndex].workedNetWeight }}</span>
                            </span>
                        </template>
                    </vxe-column>
                    <vxe-column field="decNum" title="申报数量" >
                        <template #default="{ row, $rowIndex }">
                            <span class="IssueGoodsExitRow" >
                                <el-input v-model="row.decNum" :disabled="!inWarehouseCheckbox[$rowIndex].decNum" placeholder="请输入申报数量" size="mini" onkeyup="value=value.match(/^[1-9]\d*\.?\d{0,4}|0\.\d{1,4}/) || ''" ></el-input>
                                <span class="IssueGoodsTipText">待/已下发：{{ inWarehouseCheckbox[$rowIndex].decNum }} / {{  inWarehouseCheckbox[$rowIndex].workedDecNum }}</span>
                            </span>
                        </template>
                    </vxe-column>
                    <vxe-column field="decAmount" title="申报金额" >
                        <template #default="{ row, $rowIndex }">
                            <span class="IssueGoodsExitRow">
                                <el-input v-model="row.decAmount" :disabled="!inWarehouseCheckbox[$rowIndex].decAmount" onkeyup="value=value.match(/^[1-9]\d*\.?\d{0,4}|0\.\d{1,4}/) || ''" size="mini" placeholder="请输入申报金额"></el-input>
                                <span class="IssueGoodsTipText">待/已下发：{{ inWarehouseCheckbox[$rowIndex].decAmount }} / {{  inWarehouseCheckbox[$rowIndex].workedAmount }}</span>
                            </span>
                        </template>
                    </vxe-column>
                    <vxe-column field="firstNum" title="法定第一数量" >
                        <template #default="{ row, $rowIndex }">
                            <span class="IssueGoodsExitRow">
                                <el-input v-model="row.firstNum" :disabled="!inWarehouseCheckbox[$rowIndex].firstNum" placeholder="请输入法一数量" size="mini" onkeyup="value=value.match(/^[1-9]\d*\.?\d{0,4}|0\.\d{1,4}/) || ''"></el-input>
                                <span class="IssueGoodsTipText">待/已下发：{{ inWarehouseCheckbox[$rowIndex].firstNum }} / {{  inWarehouseCheckbox[$rowIndex].workedFirstNum }}</span>
                            </span>
                        </template>
                    </vxe-column>
                    <vxe-column field="secondNum" title="法定第二数量" >
                        <template #default="{ row, $rowIndex }">
                            <span class="IssueGoodsExitRow">
                                <el-input v-model="row.secondNum" :disabled="!inWarehouseCheckbox[$rowIndex].secondNum" placeholder="请输入法二数量" size="mini" onkeyup="value=value.match(/^[1-9]\d*\.?\d{0,4}|0\.\d{1,4}/) || ''"></el-input>
                                <span class="IssueGoodsTipText">待/已下发：{{ inWarehouseCheckbox[$rowIndex].secondNum }} / {{  inWarehouseCheckbox[$rowIndex].workedSecondNum }}</span>
                            </span>
                        </template>
                    </vxe-column>
                    <!-- 硫磺列 -->
                     <!-- <vxe-column field="lotNo" title="LOT信息"  width="180" v-if="issueGoodsLOTColumn">
                        <template #default="{ row, $rowIndex }" >
                            <span v-if="row.lotNo" style="display: flex;flex-direction: column;">
                                <span>LOT号:{{ row.lotNo }} - 重量:{{ row.lotKgs }}</span>
                                <span>订单号:{{ row.lotOrderNo }} </span>
                                <span>物料号:{{ row.lotMaterialNo }}</span>
                            </span>
                            <span v-else></span>
                        </template>
                    </vxe-column> -->
                </vxe-table>
                <span slot="footer" class="dialog-footer">
                    <el-button size="mini" @click="IssueGoodsClose">取 消</el-button>
                    <el-button size="mini" type="primary" @click="saveIssueGoods">保 存</el-button>
                </span>
            </el-dialog>
            <el-dialog title="编辑作业信息" width="70%" :visible.sync="exitIssueGoodsVisible" :before-close="exitIssueGoodsClose" v-dialogDrag
             :close-on-click-modal="false" >
                <el-form class="demo-form-inline" :inline="true" ref="exitIssueGoodsForm" :model="exitIssueGoodsForm" 
                size="mini" label-width="100px">
                    <el-form-item label="下发人" prop="createMan" > 
                        <el-input disabled v-model="exitIssueGoodsForm.createMan" suffix-icon="xxxx" ></el-input>
                    </el-form-item>
                    <el-form-item label="司机" prop="driver" > 
                        <el-input  v-model="exitIssueGoodsForm.driver" suffix-icon="xxxx" ></el-input>
                    </el-form-item>
                    <el-form-item label="车牌" prop="truckNo" > 
                        <el-select class="width_100" v-model="exitIssueGoodsForm.truckNo" placeholder="请选择或输入车牌" filterable remote @focus="driverTruckNoList=[]"
                        :remote-method="truckNoRemoteMethod" @change="truckNoHandleChange($event,'exitIssueGoodsForm')" @blur="selectTruckNo($event,'exitIssueGoodsForm')" :default-first-option="true" >
                            <el-option v-for="item in driverTruckNoList" :key="item.id" :label="item.carNo" :value="item.carNo + '-' + item.driver " >
                                <span>{{ item.carNo }} - {{ item.driver }} </span>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="理货员" prop="storekeeper"> 
                        <el-input disabled v-model="exitIssueGoodsForm.createMan" suffix-icon="xxxx" ></el-input>
                    </el-form-item>
                    <el-form-item label="备注" prop="opNote"> 
                        <el-input disabled placeholder="" v-model="exitIssueGoodsForm.opNote" style="width:800px"  suffix-icon="xxxx"></el-input>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button size="mini" @click="exitIssueGoodsClose">取 消</el-button>
                    <el-button size="mini" type="primary" @click="saveExitIssueGoods">保 存</el-button>
                </span>
            </el-dialog>
            <!-- 查看完成后的任务信息 and 如果是未完成状态则完成任务单 -->
            <viewCompletework :viewCompleteworkVisible="viewCompleteworkVisible" :completeworkRow="completeworkRow"
            @viewCompleteworkClose="viewCompleteworkClose"></viewCompletework>

    </div>
</template>

<script>
import userProfile from '@/mixins/userProfile.js'
import AEObasicData from '@/config/AEObasicData.js'
import basicData from '@/config/basicData.js'
// import { webapp_ws_ajax_run, webapp_urlprotocol_startup, urlAddRandomNo,webapp_ws_autoupdate, webapp_ws_ajax_together } from "../../utils/reports/grwebapp";
import { webapp_ws_ajax_run, webapp_urlprotocol_startup, urlAddRandomNo,webapp_ws_autoupdate, webapp_ws_ajax_together } from "../../utils/reports/grwebapp";
// 提前把所有 Logo 转成 base64 引入
import logoImg from '../../assets/images/logo_name.png';
// 查看完成作业弹窗
import viewCompletework from '@/components/wms/viewCompletework.vue'
import clean from 'lodash-clean';
export default {
    name: 'inWarehouse',
    mixins: [userProfile],
    components:{
        viewCompletework
    },
    watch: { 
        inWarehouseData:{
            handler(newVal,oldVal) {
                if(newVal.length){
                    const { totalQty1,totalQty2, totalNetWeight } = newVal.reduce(
                        (acc, item) => {
                            acc.totalQty1 += item.qty1 || 0;
                            acc.totalQty2 += item.qty2 || 0;
                            acc.totalNetWeight += item.netWeight || 0;
                            return acc;
                        },
                        { totalQty1: 0,totalQty2: 0, totalNetWeight: 0 } // 初始值
                    );
                    this.warehousingForm.netWeight = totalNetWeight
                    this.warehousingForm.qty1Sum = totalQty1
                    this.warehousingForm.qty2Sum = totalQty2
                }
            }
        },
        // 根据仓库不同切换不同的理货员
        'warehousingForm.ckName':{
            handler(newVal, oldVal) {
                if (newVal === '纽约路仓库') {
                    // 根据仓库名称切换理货员
                    this.storekeeperList = basicData.storekeeperList ;
                }else if (newVal === '七星河路仓库'){
                    this.storekeeperList = basicData.storekeeperListOut ;
                }else{
                    this.storekeeperList = []
                }
            },
            immediate: true, // 是否立即执行一次
            deep: false // 是否深度监听
        },
    },
    data() {
        // // 自定义验证函数   下发净重
        // const validateNetWeight = (rule, value, callback) => {
        //     if (!value) {
        //         return callback(new Error("请输入净重")); // 非空校验
        //     }
        //     if (isNaN(value) || Number(value) === 0) {
        //         return callback(new Error("必须输入数字且不能为0")); // 必须是数字
        //     }
        //     if (value === 0) {
        //         return callback(new Error("不能为0")); // 不能为0
        //     }
        //     const remainingWeight = parseFloat(this.inWarehouseRows.netWeight) - parseFloat(this.inWarehouseRows.workedNetWeight)
        //     if (parseFloat(value) > remainingWeight) {
        //         return callback(new Error(`净重不能超过 ${remainingWeight}`)); // 不能超过最大值
        //     }
        //     callback(); // 验证通过
        // };
        // 新增货物时不可填0
        const inWarehouseRulesZero= (rule, value, callback) => {
            if (isNaN(value) || Number(value) === 0) {
                return callback(new Error("必须输入数字且不能为0")); // 必须是数字
            }
            callback(); // 验证通过
        };
        // childList可见方法
        const IssueGoodsRowExpandShow = {
            visibleMethod({ row }) {
                if (row.childList && row.childList.length > 0) {
                    return true;
                }
                return false;
            }
        };
        return {
            editConfig:false, // 控制任务是否可编辑
            inWarehouseCustomConfig:null, // 自定义表格配置
            warehousingForm:{ // 表头
                id:'', 
                taskType: '入库', // 出入库类型
                billNo:'', // 入库单号
                taskStatus:'新建', // 状态
                createUser:'', // 单证人
                createDate:'', // 创建日期
                planDate:'', // 计划作业日期
                blNo:'', // 提单号
                isBonded:'' , // 保税属性
                handbook:'' , // 账册编号
                cusDeclNo:'', // 报关单号
                invDecNo:'', // 核注清单号
                customer:'', // 委托单位
                ownerName:'', // 货主单位
                ckName:'', // 仓库
                boxType:'', // 箱型
                boxNum:'', // 箱量
                grossWeight:'', // 毛重(总)
                netWeight:'', // 净重(总)
                qty1Sum:'', // 件数1(总)
                qty1Unit:'', // 件数1单位
                qty2Sum:'', // 件数2(总)
                qty2Unit:'', // 件数2单位
                volume:'', // 体积(总)
                goodsDes:'', // 货物名称
            },
            // editConfig:false, // 是否可以编辑表头
            bondedTypeList:[], // 保税属性列表
            originalOondedTypeList:[], // 保税属性列表-不变
            handBookNoList:[], // 账册编号列表
            customerList:[], // 委托单位列表
            ckNameList:[], // 仓库列表
            boxTypeList:[], // 箱型列表
            driverTruckNoList:[], // 司机车牌列表
            // qtyUnitList:AEObasicData.QTY_UNIT, // 件数单位
            hasHandledToken: false, // 是否处理过token
            // 表头验证规则
            warehousingFormRules:{
                blNo:[
                    { required: true, message: '请输入提单号', trigger: 'blur' }
                ],
                isBonded: [
                    { required: true, message: '请选择保税类型', trigger: 'change' }
                ],
                cusDeclNo: [
                    { required: true, message: '请输入报关单号', trigger: 'blur' }
                ],
                invDecNo: [
                    { required: true, message: '请输入核注清单号', trigger: 'blur' }
                ],
                customer: [
                    { required: true, message: '请选择委托单位', trigger: 'change' }
                ],
                ownerName: [
                    { required: true, message: '请选择货主单位', trigger: 'change' }
                ],
                ckName: [
                    { required: true, message: '请选择仓库', trigger: 'change' }
                ],
                handbook:[
                    { required: true, message: '请选择账册编号', trigger: 'change' }
                ],
            },
            // 表体数据
            inWarehouseData:[],
            //实际使用的列配置（从本地存储恢复或用默认）
            inWarehouseColumns:[],
            addGoodsExit:true, // 是否可以编辑计划行信息
            addGoodsVisible:false, // 新增货物信息弹窗显示
            goodsList:[], // 货物列表
            placeList:[], // 库区列表
            locationList:[], // 库位列表
            unitList:AEObasicData.CUS_UNIT, // 计量单位
            currencyList:AEObasicData.CUS_MAPPING_CURRENCY_CODE_V, // 币制列表
            countryList: [], // 国家
            inWarehouseRows:{}, // 货物行选中信息
            inWarehouseCheckbox:[], // 货物信息多选行
            inWarehouseCheckboxExitRow:[], // 货物信息下发编辑
            IssueGoodsRows:[], // 作业信息选中行
            addGoodsForm:{
                interId:'',// 父任务单id
                rowStatus: '', // 状态   
                goodsName: '', // 货物名称
                hsCode: '', // 货物编码
                goodsType: '', // 货物类别
                packageType:'', // 包装
                spec:'', // 规格
                qty1:'', // 件数1
                qty1Unit:'', // 件数1单位
                qty2:'', // 件数2
                qty2Unit:'', // 件数2单位
                decPrice:'', // 单价
                decAmount:'', // 总价（申报金额）
                netWeight:'', // 净重
                vol:'', // 体积
                decNum:'', // 申报数量
                decUnit:'', // 申报单位代码
                decCurrency:'', // 币制
                originCountry:'', // 原产地
                firstNum:'', // 法一数
                lawUnitFirst:'', // 法一单位
                secondNum:'', // 法二数
                lawUnitSecond:'', // 法二单位
                sealNo:'', // 铅封号
                boxNo:'', // 箱号
                itemNo:'', // 项号
                skuNo:'', // 商品料号
                driver :'', // 司机
                truckNo :'', // 车牌
                taskNote:'', // 作业备注
                lotOrderNo:'', // 订单号
                lotMaterialNo:'', // 物料号
            },
            // 表体保存规则
            inWarehouseRules:{
                goodsName: [
                    { required: true, message: '请选择货物名称', trigger: 'change' }
                ],
                spec: [
                    { required: true, message: '请输入规格型号', trigger: 'blur' }
                ],
                goodsPart: [
                    { required: true, message: '请输入商品料号', trigger: 'blur' }
                ],
                netWeight: [
                    { required: true, message: '请输入净重', trigger: 'blur' },
                    { validator: inWarehouseRulesZero, trigger: "blur" }
                ],
                qty1: [
                    { required: true, message: '请输入件数', trigger: 'blur' },
                    { validator: inWarehouseRulesZero, trigger: "blur" }
                ],
                qty1Unit:[
                    { required: true, message: '请选择件数1单位', trigger: 'change' }
                ],
                decUnit: [
                    { required: true, message: '请选择申报单位', trigger: 'change' }
                ],
                decPrice:[
                    { required: true, message: '请输入单价', trigger: 'blur' },
                    { validator: inWarehouseRulesZero, trigger: "blur" }
                ],
                decNum:[
                    { required: true, message: '请输入申报数量', trigger: 'blur' },
                    { validator: inWarehouseRulesZero, trigger: "blur" }
                ],
                decAmount:[
                    { required: true, message: '请输入申报金额', trigger: 'blur' },
                    { validator: inWarehouseRulesZero, trigger: "blur" }
                ],
                decCurrency:[
                    { required: true, message: '请选择币制', trigger: 'change' }
                ],
                firstNum:[
                    { required: true, message: '请输入法定第一数量', trigger: 'blur' },
                    { validator: inWarehouseRulesZero, trigger: "blur" }
                ],
                lotOrderNo:[
                    { required: true, message: '请输入LOT订单号', trigger: 'blur' },
                ],
                lotMaterialNo:[
                    { required: true, message: '请输入LOT物料号', trigger: 'blur' },
                ],
            },
            // 下发任务弹窗
            IssueGoodsVisible:false,
            // 下发任务表单
            issueGoodsForm:{
                taskType:'入库作业', // 任务类型
                storekeeper:'', // 理货员
                driver:'', // 司机
                truckNo :'', // 车牌
                sealNo:'', // 铅封号
                boxNo:'', // 箱号
                interId:'', // 主id
                createUser:'', // 单证员
                remark:'', // 备注
                handbook:'', // 账册编号
                ckName:'', // 仓库
                blNo:'', // 提单号
                cusDeclNo:'', // 报关单号
                invDecNo:'', // 核注清单号
                isBonded:'', // 保税类型
                boxType:'', // 箱型
                boxNum:'', // 箱量
                ownerName:'', // 货主
                childList:[],
                note:'',
                lotNo:'',
                lotKgs:'',
                lotOrderNo:'',
                lotMaterialNo:'',
            },
            issueGoodsLOTColumn:false, // 下发暂存的时候是否显示LOT
            IssueGoodsData:[], // 下发任务表格
            // 理货员列表
            storekeeperList:[],
            issueGoodsFormRules:{ // 下发表单规则
                storekeeper:[
                    { required: true, message: '请选择理货员', trigger: 'change' }
                ],
                driver:[
                    { required: true, message: '请输入司机', trigger: 'blur' },
                ],
                truckNo:[
                    { required: true, message: '请输入车牌', trigger: 'blur' },
                ],
                lotNo:[
                    { required: true, message: '请输入LOT号', trigger: 'blur' }
                ],
                lotOrderNo:[
                    { required: true, message: '请输入LOT订单号', trigger: 'blur' }
                ],
                lotMaterialNo:[
                    { required: true, message: '请输入LOT物料号', trigger: 'blur' }
                ],
                lotKgs:[
                    { required: true, message: '请输入LOT重量', trigger: 'blur' },
                    { validator: inWarehouseRulesZero, trigger: "blur" }
                ],
            },
            IssueGoodscheckboxConfig:{
                labelField: 'name',
                checkMethod: ({ row }) => {
                    return row.rowStatus === '暂存' ;
                }
            },
            IssueGoodsRowExpandShow,
            IssueGoodsTabs:'first', // 作业信息tab切换
            IssueGoodsAllJob:[], // 所有的作业详情
            exitIssueGoodsForm:{}, // 编辑作业信息-车牌司机
            exitIssueGoodsVisible:false, // 编辑作业信息弹窗
            // LotNoFile:[], // 上传lot文件
            // lotNoURL:'', // 上传lotURL
            // 确认作业完成时上传受理单、车辆货物、异常等图片
            // 查看完成作业弹窗
            viewCompleteworkVisible:false,
            completeworkRow:{}, // 完成的row信息
            copySulfurVisible:false, // 批量复制弹窗
            copySulfurType:'', // 批量复制类型
            copySulfurTextLH:'', // 复制硫磺
            copySulfurTextXH:'', // 复制箱号
            copySulfurTextQFH:'', // 复制铅封号
            copySulfurTextFlag:false, // 是否合并,合并打勾,1
        }
    },
    created() {
        window.addEventListener('message', (event) => {
            if (event.source === window) {
                // 当页面消息来自自己时（F5刷新）并且hasHandledToken为false时（证明是第一次执行，保证接口只调用一次）
                if(localStorage.getItem('id') && !this.hasHandledToken){
                    this.inWarehouseCustomConfig = this.customConfig // 表格定义列
                    this.getIsBonded()
                    this.getckNameList()
                    this.getCompanyList()
                    this.getBoxTypeList()
                    this.getWMSTaskDetail(localStorage.getItem('id'))
                }
                return false
            }
            // 父页面消息
            this.handleMessage(event);
        });
    },
    mounted() {
        webapp_urlprotocol_startup(); 
        // 获取当前日期
        this.warehousingForm.createDate = new Date().toISOString().split('T')[0] // 格式化为 "2026-02-03"
        window.addEventListener('beforeunload', this.notifyParentBeforeUnload);
        // 监听父页面消息
        this.setupMessageListener();
        // 监听页面关闭
    },
    computed:{
    },
    methods: {
        // 通用查找方法
        findNameByCode(code, list) {
            if (!code) return '';
            const item = list.find(item => item.codeValue === code);
            return item ? item.codeName : code; // 找不到就返回原编码
        },
        // 处理整个数组的数据转换
        processTableData(data) {
            return data.map(item => ({
            ...item,
            decCurrencyName: this.findNameByCode(item.decCurrency, this.currencyList), // 币制
            originCountryName: this.findNameByCode(item.originCountry, AEObasicData.CUS_MAPPING_COUNTRY_CODE_V), // 原产地
            lawUnitFirstName: this.findNameByCode(item.lawUnitFirst,  this.unitList), // 法一单位
            lawUnitSecondName: this.findNameByCode(item.lawUnitSecond,  this.unitList), // 法二单位
            decUnitName: this.findNameByCode(item.decUnit,  this.unitList), // 申报单位
            qty1UnitName: this.findNameByCode(item.qty1Unit, this.unitList), // 件数1单位
            qty2UnitName: this.findNameByCode(item.qty2Unit, this.unitList), // 件数2单位
            // packageTypeName: this.findNameByCode(item.packageType, this.lawUnitList), // 包装
            }));
        },
        // 接收父窗口的消息
        handleMessage(event) {
                if(event.data.type === 'SET_TOKEN' && !this.hasHandledToken) {
                    this.hasHandledToken = true;
                    localStorage.clear();
                    localStorage.setItem('parentOrigin', event.data.parentOrigin);
                    localStorage.setItem('token', event.data.token);
                    localStorage.setItem('name', event.data.name);
                    // 向父窗口发送消息
                    event.source.postMessage(
                        { type: 'TOKEN_RECEIVED' },
                        event.origin
                    );
                    Promise.resolve().then(() => {
                        this.inWarehouseCustomConfig = this.customConfig // 表格定义列
                        this.getIsBonded()
                        this.getckNameList()
                        this.getCompanyList()
                        this.getBoxTypeList()
                        if(event.data.id !== ''){
                            localStorage.setItem('id', event.data.id);
                            this.getWMSTaskDetail(localStorage.getItem('id'))
                        }else{
                            this.warehousingForm.createUser = event.data.name
                        }
                    })
                }
        },
        // 查询任务单详情
        getWMSTaskDetail(id){
            this.$api.getWMSTaskDetail(id).then(res =>{
                this.warehousingForm = res.taskMain
                //查询inWarehouseData中编码对应的汉字
                this.inWarehouseData = this.processTableData(res.taskSub.tableData);
                this.inWarehouseColumns = res.taskSub.columns
                // 判断是否结束
                this.editConfig = this.warehousingForm.billStatus === '结束' ? true : false
            })
        },
        // 获取箱型列表
        getBoxTypeList(){
            this.$api.getDicList( { value:'箱型'} ).then(res =>{
                this.boxTypeList = res
            })
        },
        // 获取保税属性
        getIsBonded(){
            this.$api.getDicList( { value:'Wms保税属性'} ).then(res =>{
                this.originalBondedTypeList  = res
                const currentCkName = this.warehousingForm.ckName
                // 如果当前选的是 纽约路仓库，过滤掉"非保税"；否则保留全部
                if (currentCkName === '纽约路仓库') {
                    // 过滤掉value为非保税的项
                    this.bondedTypeList = this.originalBondedTypeList.filter(
                    item => item.value !== '非保税'
                    )
                    // ✅ 关键：如果当前已经选了非保税，清空选中值，避免非法值残留
                    if (this.warehousingForm.isBonded === '非保税') {
                    this.warehousingForm.isBonded = ''
                    }
                } else {
                    // 其他仓库，恢复全量选项
                    this.bondedTypeList = [...this.originalBondedTypeList]
                }
            })
        },
        // 获取仓库
        getckNameList(){
            this.$api.getCkNamesBy(  ).then(res =>{
               this.ckNameList = res
            })
        },
        // 获取客户信息
        getCompanyList(){
            this.$api.getCompanyList(  ).then(res =>{
                this.customerList = res.tableData
            })
        },
        // 查询账册
        gethandBookNoList(){
            const parms = {
                type:this.warehousingForm.isBonded,
                ckName:this.warehousingForm.ckName
            }
            this.$api.wmsgetHandBook( parms ).then(res =>{
                this.handBookNoList = res.tableData
                if(this.handBookNoList.length){
                    this.warehousingForm.handbook = this.handBookNoList[0].bookNo
                }else{
                    this.warehousingForm.handbook = ''
                }
                // 默认赋值第一个
            })
        },
        // 当非保税的时候清空报关单号和核注清单,查询账册
        changeIsBonded(){
            if( this.warehousingForm.isBonded &&  this.warehousingForm.ckName){
                this.gethandBookNoList()
            }
            if( this.warehousingForm.isBonded === '非保税' ){
                this.warehousingForm.cusDeclNo = ''
                this.warehousingForm.invDecNo = ''
            }
        },
        // 选择仓库时
        changeCkName(){
            if( this.warehousingForm.isBonded &&  this.warehousingForm.ckName){
                this.gethandBookNoList()
            }
            const currentCkName = this.warehousingForm.ckName
            // 如果当前选的是 纽约路仓库，过滤掉"非保税"；否则保留全部
            if (currentCkName === '纽约路仓库') {
                // 过滤掉value为非保税的项
                this.bondedTypeList = this.originalBondedTypeList.filter(
                item => item.value !== '非保税'
                )
                // ✅ 关键：如果当前已经选了非保税，清空选中值，避免非法值残留
                if (this.warehousingForm.isBonded === '非保税') {
                this.warehousingForm.isBonded = ''
                }
            } else {
                // 其他仓库，恢复全量选项
                this.bondedTypeList = [...this.originalBondedTypeList]
            }
        },
        // 当选择客户的时候自动给货主赋值
        changeCustomer(){
            this.warehousingForm.ownerName = this.warehousingForm.customer
        },
        // 搜索司机-车牌
        truckNoRemoteMethod(value){
            this.$api.wmsGetCarInfo( value ).then(res =>{
                this.driverTruckNoList = res
            })
        },
        // 值变化处理
        truckNoHandleChange(value,code) {
            const item  = value.split('-')
            if(code === 'issueGoodsForm'){
                this.issueGoodsForm.truckNo = item[0]
                this.issueGoodsForm.driver = item[1]
            }else if(code === 'addGoodsForm'){
                this.addGoodsForm.truckNo = item[0]
                this.addGoodsForm.driver = item[1]
            }else if (code === 'exitIssueGoodsForm'){
                this.exitIssueGoodsForm.truckNo = item[0]
                this.exitIssueGoodsForm.driver = item[1]
            }
            
        },
        // 输入
        selectTruckNo(e,code){
            if (e.target.value !== '') {
                if(code === 'issueGoodsForm'){
                    this.issueGoodsForm.truckNo = e.target.value
                }else if(code === 'addGoodsForm'){
                    this.addGoodsForm.truckNo = e.target.value
                }else if( code === 'exitIssueGoodsForm'){
                    this.exitIssueGoodsForm.truckNo = e.target.value
                }
            }
        },
        // 保存入库任务单
        warehousingSave(){
            // 判断是否有BillNo
            this.inWarehouseRows = {}
            if(!this.warehousingForm.billNo){
                this.getWMSBillNo()
            }else{
                this.warehousingSaveMain()
            }
        },
        // 保存入库任务单表头
        getWMSBillNo(){
            // 先获取入库单号
            this.$api.getWMSBillNo( 'RK' ).then(res =>{
                this.warehousingForm.billNo = res
                this.warehousingSaveMain()
            })
            
        },
        // 调用保存入库任务单接口
        warehousingSaveMain(){
            this.$refs.warehousingForm.validate((valid) => {
                if (valid) {
                    this.$api.saveMain( this.warehousingForm ).then(res =>{
                        // 存id
                        if(localStorage.getItem('id')){
                            localStorage.setItem('id', res);
                        }
                        this.getWMSTaskDetail(res)
                        this.$message.success('保存成功')
                    })
                } else {
                    this.$message.error('请填写必填字段')
                    return false;
                }
            });
        },
        // 删除任务单
        warehousingDel(){
            this.$confirm('是否确定是删除此任务?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$api.deleteWMSTask( this.warehousingForm.id ).then(res =>{
                    this.$message.success('删除成功')
                    // 关闭此页面
                    window.close();
                })
            }).catch(() => { });  
        },
        // 新增货物计划信息
        addRows(){
           this.addGoodsVisible = true
           this.addGoodsExit = true
           this.addGoodsForm.rowStatus = '新建'
           this.addGoodsForm.interId = this.warehousingForm.id
           this.addGoodsForm.skuNo = this.warehousingForm.blNo  
        },
        // 获取货物计划列表
        getGoodsList(value){
            this.$api.getInUseListBy({param:value} ).then(res =>{
            // this.$api.wmsgetListBy( 1,100,{param:value} ).then(res =>{
                this.goodsList = res.tableData
            })
        }, 
        // 自定义筛选方法
        customFilter(query) {
            if (!query) {
                return AEObasicData.CUS_UNIT // 如果没有搜索词，返回全部数据
            }
        
            // 将搜索词转换为小写，实现不区分大小写搜索
            const searchText = query.toLowerCase().trim()
            
            // 过滤逻辑：同时匹配 codeValue 和 codeName
            this.unitList = AEObasicData.CUS_UNIT.filter(item => {
                const codeValue = item.codeValue ? item.codeValue.toString().toLowerCase() : ''
                const codeName = item.codeName ? item.codeName.toString().toLowerCase() : ''
                
                // 搜索 codeValue 或 codeName
                return codeValue.includes(searchText) || codeName.includes(searchText)
            })
        
            // 更新显示的数据（需要确保组件能响应这个变化）
            // 注意：Element UI 的 filter-method 需要返回过滤后的数组
            return this.unitList
        },
        // 当选择货物名称后赋值给类型和编码 
        goodsEnter(value){
            if(value === ''){
                this.addGoodsForm.goodsName = ''
                this.addGoodsForm.goodsType = ''
                this.addGoodsForm.hsCode = ''
                this.addGoodsForm.lawUnitFirst = ''
                this.addGoodsForm.lawUnitSecond = ''
            }else{
                const item  = value.split('-')
                this.addGoodsForm.goodsName = item[0]
                this.addGoodsForm.goodsType = item[1]
                this.addGoodsForm.hsCode = item[2]
                if(item[2]){
                    // 根据海关编码查询法一、法二、申报单位
                    this.$api.getHsCiqByHsCode(  item[2]  ).then(res =>{
                        this.addGoodsForm.lawUnitFirst =  this.unitList.filter(item =>
                            item.codeName.toLowerCase().includes(res.firstLawUnit.toLowerCase())
                        )[0].codeValue
                        this.addGoodsForm.decUnit =  this.unitList.filter(item =>
                            item.codeName.toLowerCase().includes((res.hsUnit.includes('/')?res.hsUnit.split('/')[0]:res.hsUnit).toLowerCase())
                        )[0].codeValue
                        this.addGoodsForm.lawUnitSecond = (res.secondLawUnit === '无' || res.secondLawUnit === '') ? '' :   this.unitList.filter(item =>
                            item.codeName.toLowerCase().includes(res.secondLawUnit.toLowerCase())
                        )[0].codeValue
                        this.$forceUpdate();
                    })
                }else{
                    this.addGoodsForm.lawUnitFirst = ''
                    this.addGoodsForm.decUnit = ''
                    this.addGoodsForm.lawUnitSecond = ''
                }
            }
        },
        // 查询计量单位
        // getUnitList(value){
            // if(value && value !== ' '){
            //     this.unitList = AEObasicData.CUS_UNIT.filter(item =>
            //         item.codeValue.toLowerCase().includes(value.toLowerCase()) ||
            //         item.codeName.toLowerCase().includes(value.toLowerCase())
            //     );
            // }
        // },
        // 查询国家
        getCountryList(value){
            if(value && value !== ' '){
                this.countryList = AEObasicData.CUS_MAPPING_COUNTRY_CODE_V.filter(item =>
                    item.codeValue.toLowerCase().includes(value.toLowerCase()) ||
                    item.codeName.toLowerCase().includes(value.toLowerCase()) || 
                    item.cusCode.toLowerCase().includes(value.toLowerCase())
                );
            }
        },
        // 关闭新增货物信息弹窗
        addGoodsClose(){
            this.addGoodsVisible = false
            this.addGoodsForm = {}
            this.$refs.addGoodsForm.resetFields();
        },
        // 保存新增货物信息
        saveAddGoods(){
            this.$refs.addGoodsForm.validate((valid) => {
                if (valid) {
                    this.addGoodsForm.blNo = this.warehousingForm.blNo
                    this.addGoodsForm.taskType='入库'
                    const tempForm = { ...this.addGoodsForm };
                    // 非硫磺商品，移除拷贝对象中的两个字段 lotOrderNo lotMaterialNo
                    if (!tempForm.goodsName?.includes('硫磺')) {
                        delete tempForm.lotOrderNo;
                        delete tempForm.lotMaterialNo;
                    }
                    const params = clean(tempForm);
                    this.$api.insOneRecordWMSTask(params).then(res =>{
                        this.$message.success('保存成功')
                        this.addGoodsClose()
                        this.getWMSTaskDetail(this.warehousingForm.id)
                        // 清空行选中值 
                        this.inWarehouseRows = {}
                        this.inWarehouseCheckbox = []
                        this.$refs.inWarehouseTable.clearCurrentRow();
                    })
                } else {
                    this.$message.error('请填写必填字段')
                    return false;
                }
            })
        },
        // 输入货物计划中净重时，同时修改第一法定数量和申报数量,如果单价有值则计算申报金额
        blurNetWeight(){
            this.addGoodsForm.firstNum = this.addGoodsForm.netWeight
            // this.addGoodsForm.firstNum =  this.addGoodsForm.lawUnitFirst !== '' ? this.addGoodsForm.netWeight : ''
            this.addGoodsForm.decNum = this.addGoodsForm.netWeight
            if(this.addGoodsForm.decPrice){
                const decPrice = this.addGoodsForm.netWeight * this.addGoodsForm.decPrice
                this.addGoodsForm.decAmount = Math.round(decPrice * 10000) / 10000
            }
            // 强制更新视图
            this.$forceUpdate();
        },
        // 输入货物计划中单价时，如果净重有值则计算申报金额
        blurDecPrice(){
            if(this.addGoodsForm.netWeight){
                const product = this.addGoodsForm.netWeight * this.addGoodsForm.decPrice;
                this.addGoodsForm.decAmount = Math.round(product * 10000) / 10000;
            }  
            this.$forceUpdate();
        },
        // 货物行选中
        inWarehouseRowsChange( { row }){
            this.inWarehouseRows = row
            // 查询下发任务列表
            this.wmsGetOpsBySubId(row.id)
        },
        // 多选货物选中行
        inWarehouseRowsCheckbox(){
            const selectedRecords = this.$refs.inWarehouseTable.getCheckboxRecords();
            this.inWarehouseCheckbox = selectedRecords
            // 深拷贝一个用来修改下发件数等信息
            this.inWarehouseCheckboxExitRow = JSON.parse(JSON.stringify(selectedRecords))
        },
        // 编辑货物计划信息
        exitRows(){
            // 判断是否选中行数据
            if( !this.inWarehouseRows.id ){
                this.$message({
                    message: '请先选中计划信息',
                    type: 'warning'
                });
                return false
            }
            // 判断选中的行信息是否可以编辑，如果是新建则可以编辑全部信息，如果是完成或下发只能编辑项号
            if(this.inWarehouseRows.rowStatus === '新建'){
                this.addGoodsExit = true
            }else{
                // 只能编辑项号
                this.addGoodsExit = false
            }
            this.addGoodsVisible = true
            this.addGoodsForm =  JSON.parse(JSON.stringify(this.inWarehouseRows))
            // 查询原产国
            this.getCountryList(this.addGoodsForm.originCountry)
        },
        // 多选删除计划信息
        delRows(){
            if( !this.inWarehouseCheckbox.length ){
                this.$message({
                    message: '请先选中计划信息',
                    type: 'warning'
                });
                return false
            }
            // 判断选中计划信息是否可以下发暂存
            const hasInvalidStatus = this.inWarehouseCheckbox.some(item => {
                return item.rowStatus === '已指派' || item.rowStatus === '完成';
            });
            
            if (hasInvalidStatus) {
                this.$message.warning('包含已指派或完成状态的数据，不可删除');
                return false;
            }
            const idList = this.inWarehouseCheckbox.map(item => item.id);
            this.$confirm('是否确定删除此行货物信息?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$api.wmsDeleteSubsBatch( idList ).then(res =>{
                    this.$message.success('删除成功')
                    // 刷新数据
                    this.getWMSTaskDetail(this.warehousingForm.id)
                })
            }).catch(() => { });  
        },
        // 复制行货物信息
        copyRows(){
            if( !this.inWarehouseRows.id ){
                this.$message({
                    message: '请先选中货物信息',
                    type: 'warning'
                });
                return false
            }
            this.addGoodsVisible = true
            const {workedAmount,workedDecNum,workedFirstNum,workedNetWeight,workedQty1,workedQty2,workedSecondNum,workedVol,itemNo, ...param } = this.inWarehouseRows
            this.addGoodsForm = param
            this.addGoodsForm.id = null
            this.addGoodsForm.rowStatus = null
            // 复制可以编辑
            this.addGoodsExit = true
        },
        // // 复制硫磺
        // copyRowsLH(){
        //     if( !this.inWarehouseRows.id ){
        //         this.$message({
        //             message: '请先选中货物信息',
        //             type: 'warning'
        //         });
        //         return false
        //     }
        //     // 判断选中的是否是硫磺
        //     if( this.inWarehouseRows.goodsName.includes('硫磺') ){
        //         this.copySulfurVisible = true
        //         this.copySulfurType = '硫磺'
        //     }else{
        //         this.$message({
        //             message: '请先选中硫磺信息',
        //             type: 'warning'
        //         });
        //     }
        // },
        // 复制箱号/铅封号
        copyRowsXH(){
            if( !this.inWarehouseRows.id ){
                this.$message({
                    message: '请先选中货物信息',
                    type: 'warning'
                });
                return false
            }
            this.copySulfurVisible = true
            this.copySulfurType = '箱号/铅封号'
        },
        // 关闭批量复制硫磺窗口
        copySulfurClose(){
            this.copySulfurVisible = false
            // this.copySulfurTextLH = ''
            this.copySulfurTextXH = ''
            this.copySulfurTextQFH = ''
            this.copySulfurType = ''
            this.copySulfurTextFlag = false
        },
        // 批量复制
        saveCopySulfur(){
            // 将文字改成数组
            // if(this.copySulfurType === '硫磺'){
            //     const LOTarray = this.copySulfurTextLH.split(/[,\n\r]+/).filter(item => item.trim());
            //     this.$api.wmsCopyBeanById( this.inWarehouseRows.id,LOTarray ).then(res =>{
            //         this.$message.success('复制成功')
            //         // 刷新数据
            //         this.getWMSTaskDetail(this.warehousingForm.id)
            //         this.copySulfurClose()
            //     })
            // } else {
                if(!this.copySulfurTextXH){
                    this.$message.warning('请输入箱号')
                    return false
                }
                var XHarray = this.copySulfurTextXH.split(/[,\n\r]+/).filter(item => item.trim());
                var QFHarray = this.copySulfurTextQFH.split(/[,\n\r]+/).filter(item => item.trim());
                if(QFHarray.length === 0){
                    QFHarray = new Array(XHarray.length).fill('')
                }
                const params = {
                    boxNos:XHarray,
                    sealNos:QFHarray,
                }
                   
                const  flag = this.copySulfurTextFlag ? 1:0
                this.$api.wmsCopyTaskByBoxNo( this.inWarehouseRows.id,flag,params ).then(res =>{
                    this.$message.success('复制成功')
                    // 刷新数据
                    this.getWMSTaskDetail(this.warehousingForm.id)
                    this.copySulfurClose()
                })
            // }   

        },
        // 下发暂存
        async IssueRowsSave(){
            // 判断是否选中数据，多选
            if( !this.inWarehouseCheckbox.length ){
                this.$message({
                    message: '请先选中计划信息',
                    type: 'warning'
                });
                return false
            }
            // 判断选中计划信息是否可以下发暂存
            const hasInvalidStatus = this.inWarehouseCheckbox.some(item => {
                return item.rowStatus === '已指派' || item.rowStatus === '完成';
            });
            
            if (hasInvalidStatus) {
                this.$message.warning('包含已指派或完成状态的数据，不可下发暂存');
                return false;
            }
            // 判断选中信息是否是多行
            if(this.inWarehouseCheckboxExitRow.length > 1){
                // 多行则调接口判断 司机、车牌、箱号、铅封号是否相同，不相同则不允许一起下发
                try {
                    const ids = this.inWarehouseCheckboxExitRow.map(item => item.id)
                    await this.$api.wmsCheckCanIssue(ids);
                } catch (error) {
                    console.error('接口调用失败:', error);
                    return;
                }
            }
            //  检查货物名称中是否包含硫磺（如果有需要）
            const hasSulfur = this.inWarehouseCheckbox.some(item => 
                item.goodsName && item.goodsName.includes('硫磺')
            );
            // 如果有硫磺则只能选择一行下发
            if(this.issueGoodsLOTColumn && this.inWarehouseCheckbox.length > 1){
                this.$message.warning('硫磺下发只可选择一条计划信息')
            }
            // 赋值司机、车牌、箱号、铅封号
            // 如果是一行或者相同则直接赋值
            this.issueGoodsForm.driver = this.inWarehouseCheckboxExitRow[0].driver ? this.inWarehouseCheckboxExitRow[0].driver : ''
            this.issueGoodsForm.truckNo = this.inWarehouseCheckboxExitRow[0].truckNo ? this.inWarehouseCheckboxExitRow[0].truckNo : ''
            this.issueGoodsForm.sealNo = this.inWarehouseCheckboxExitRow[0].sealNo ? this.inWarehouseCheckboxExitRow[0].sealNo : ''
            this.issueGoodsForm.boxNo = this.inWarehouseCheckboxExitRow[0].boxNo ? this.inWarehouseCheckboxExitRow[0].boxNo : ''
            this.issueGoodsForm.lotOrderNo = ''
            this.issueGoodsForm.lotMaterialNo = ''
            this.issueGoodsForm.lotKgs = ''
            this.issueGoodsForm.lotNo = ''
            // 有硫磺则显示表格列
            if (hasSulfur) {
                this.issueGoodsLOTColumn = true
                this.issueGoodsForm.lotOrderNo = this.inWarehouseCheckboxExitRow[0].lotOrderNo
                this.issueGoodsForm.lotMaterialNo = this.inWarehouseCheckboxExitRow[0].lotMaterialNo
            }
            // 将下发信息的净重和件数修改为可以下发的最大值
            this.inWarehouseCheckboxExitRow.forEach((row, index) => {
                row.decAmount = this.inWarehouseCheckbox[index].decAmount ? parseFloat(this.inWarehouseCheckbox[index].decAmount) - parseFloat(this.inWarehouseCheckbox[index].workedAmount) :''
                // this.issueGoodsForm.vol = this.inWarehouseRows.vol ? parseFloat(this.inWarehouseRows.vol) - parseFloat(this.inWarehouseRows.workedVol) : ''
                row.netWeight = parseFloat(this.inWarehouseCheckbox[index].netWeight) - parseFloat(this.inWarehouseCheckbox[index].workedNetWeight)
                row.decNum = this.inWarehouseCheckbox[index].decNum? parseFloat(this.inWarehouseCheckbox[index].decNum) - parseFloat(this.inWarehouseCheckbox[index].workedDecNum) :''
                row.firstNum = parseFloat(this.inWarehouseCheckbox[index].firstNum) - parseFloat(this.inWarehouseCheckbox[index].workedFirstNum)
                row.secondNum = this.inWarehouseCheckbox[index].secondNum ? parseFloat(this.inWarehouseCheckbox[index].secondNum) - parseFloat(this.inWarehouseCheckbox[index].workedSecondNum) : ''
                row.qty1 = parseFloat(this.inWarehouseCheckbox[index].qty1) - parseFloat(this.inWarehouseCheckbox[index].workedQty1)
                row.qty2 =  this.inWarehouseCheckbox[index].qty2 ?  parseFloat(this.inWarehouseCheckbox[index].qty2) - parseFloat(this.inWarehouseCheckbox[index].workedQty2) : ''
            })
            // 判断是否有包含硫磺，包含硫磺则显示列
            await this.$nextTick()
            this.IssueGoodsVisible = true
            // 获取库区信息
           this.getStore(this.warehousingForm.ckName)
        },
        // 获取库区列表
        getStore(ckName){
            this.$api.getStore( ckName ).then(res =>{
                this.placeList = res
            })
        },
        // 根据库区查询库位列表
        placeEnter(value,row,rowIndex){
            if(value === ''){
                this.locationList = []
                row.place = ''
            }else{
                const placeItem  = value.split('-')
                // this.getLocation(placeItem[1])
                // 如果是第一行则下面的行全部赋值
                if(rowIndex === 0){
                    this.inWarehouseCheckboxExitRow.forEach((item, i) => {
                        // 使用 $set 确保响应式更新
                        this.$set(this.inWarehouseCheckboxExitRow[i], 'place', placeItem[0]);
                    });
                }else{
                    // 使用 $set 确保响应式更新
                    this.$set(this.inWarehouseCheckboxExitRow[rowIndex], 'place', placeItem[0]);
                }
            }
            if(rowIndex === 0){
                this.inWarehouseCheckboxExitRow.forEach((item, i) => {
                    // 使用 $set 确保响应式更新
                    this.$set(this.inWarehouseCheckboxExitRow[i], 'location', '');
                });
            }else{
                this.inWarehouseCheckboxExitRow.forEach((item, i) => {
                    // 使用 $set 确保响应式更新
                    if(rowIndex === i){
                        this.$set(this.inWarehouseCheckboxExitRow[i], 'location', '');
                    }
                });
            }
        },
        // 批量填充库位
        locationEnter(value,row,rowIndex){
            if(value !== ''){
                // 如果是第一行则下面的行全部赋值
                if(rowIndex === 0){
                    this.inWarehouseCheckboxExitRow.forEach((item, i) => {
                        // 使用 $set 确保响应式更新
                        this.$set(this.inWarehouseCheckboxExitRow[i], 'location', value);
                        
                    });
                }
            }
        },  
        // 库位聚焦
        locationRowFocus(row,rowIndex){
            if(row.place){
                const targetPlace = this.placeList.find(item => item.name === row.place)
                this.getLocation(targetPlace.id)
            }
        },
        // 查询库位列表
        getLocation(id){
            this.$api.getLocation( id ).then(res =>{
                this.locationList = res
            })
        },
        // 关闭下发任务弹窗
        IssueGoodsClose(){
            this.IssueGoodsVisible = false
            this.issueGoodsLOTColumn = false
            this.$refs.issueGoodsForm.resetFields();
            this.issueGoodsForm.decAmount = 0
            this.inWarehouseCheckboxExitRow = []
            // 清空表格选择
            this.$refs.inWarehouseTable.clearCheckboxRow();
            // 查询下发任务
        },
        // 修改下发暂存的时候件数1，同步修改净重、申报数量、申报金额
        IssueGoodsRowQty1Blur(row ,index){
            if(row.qty1 > this.inWarehouseCheckbox[index].qty1){
                this.$message.warning(`大于计划件数1 ，请调整！`);
                row.qty1 = ''
                return false
            }
            row.qty2 = this.calculateAllPlanFields(this.inWarehouseCheckbox[index].qty2,this.inWarehouseCheckbox[index].qty1,row.qty1)
            row.netWeight = this.calculateAllPlanFields(this.inWarehouseCheckbox[index].netWeight,this.inWarehouseCheckbox[index].qty1,row.qty1)
            row.decNum = this.calculateAllPlanFields(this.inWarehouseCheckbox[index].decNum,this.inWarehouseCheckbox[index].qty1,row.qty1)
            row.decAmount = this.calculateAllPlanFields(this.inWarehouseCheckbox[index].decAmount,this.inWarehouseCheckbox[index].qty1,row.qty1)
            row.firstNum = this.calculateAllPlanFields(this.inWarehouseCheckbox[index].firstNum,this.inWarehouseCheckbox[index].qty1,row.qty1)
            row.secondNum = this.calculateAllPlanFields(this.inWarehouseCheckbox[index].secondNum,this.inWarehouseCheckbox[index].qty1,row.qty1)
            this.$forceUpdate();
        },
        // 净重、申报数量、金额、件数2，法一，法二 计算
        calculateAllPlanFields(number,qty1Value,planQty1Value){
            if(!number){
                return null
            }else{
                const value = Number(number) || 0;
                const qty1 = Number(qty1Value); // 选中数据的件数1
                const planQty1 = Number(planQty1Value); // 填写出库的件数1
                // 计算并保留指定位小数
                const result = (value / qty1) * planQty1;
                
                const factor = Math.pow(10, 4);  // 10000
                // Number.EPSILON  大约是 2.220446049250313e-16 这是 JavaScript 中最小的正数用于解决浮点数计算中的精度问题
                return Math.round((result + Number.EPSILON) * factor) / factor;  // 加一个极小的数，避免浮点数误差;乘以10^4，将小数变为整数,四舍五入
            }
        },
        // 下发的时候修改净重跟随修改申报数量和法一数量、金额
        blurNetWeightIssueGoods(row, rowIndex){
            row.firstNum = (row.lawUnitFirst !== '' && row.lawUnitFirst) ? row.netWeight : ''
            row.decNum = row.netWeight
            if(row.decPrice){
                const decPrice = row.netWeight * row.decPrice
                row.decAmount = Math.round(decPrice * 10000) / 10000
            }
            this.$forceUpdate();
        },
        // 保存下发暂存任务弹窗
        async saveIssueGoods(){
            // 判断
            this.$refs.issueGoodsForm.validate(async (valid) => {
                if (valid) {
                    // 验证下发信息库位填写完成
                    const placeAndlocation = await this.inWarehouseCheckboxExitRow.every(item => 
                        item.place && item.place.trim() && 
                        item.location && item.location.trim()
                    )
                    if(!placeAndlocation){
                        this.$message.warning('请填写库区库位信息')
                        return false
                    }
                    // 验证件数1等数值是否填写完整
                    const validationErrors = await this.validateTable()
                    if (validationErrors.length > 0) {
                        // 显示错误信息
                        this.$message.warning('请填写完整件数1、件数2、净重、申报数量、申报金额等数值')
                        return false
                    }
                    // 执行保存函数
                    await this.wmsSaveOpTask();
                } else {
                    this.$message.error('请填写必填字段')
                    return false;
                }
            })
        },
        // 验证表格输入
        validateTable() {
            const errors = []
            this.inWarehouseCheckboxExitRow.forEach((row, index) => {
                // 验证 qty1
                if (this.isEmptyOrZero(row.qty1)) {
                    errors.push(`第${index + 1}行：件数1不能为空且不能为0`)
                }
                // 验证 qty2（如果启用）
                if (!!this.inWarehouseCheckbox[index]?.qty2  && this.isEmptyOrZero(row.qty2)) {
                    errors.push(`第${index + 1}行：件数2不能为空且不能为0`)
                }
                // 验证 netWeight（如果启用）
                if (!!this.inWarehouseCheckbox[index]?.netWeight && this.isEmptyOrZero(row.netWeight)) {
                    errors.push(`第${index + 1}行：净重不能为空且不能为0`)
                }
                // 验证 decNum（如果启用）
                if (!!this.inWarehouseCheckbox[index]?.decNum && this.isEmptyOrZero(row.decNum)) {
                    errors.push(`第${index + 1}行：申报数量不能为空且不能为0`)
                }
                // 验证 decAmount（如果启用）
                if (!!this.inWarehouseCheckbox[index]?.decAmount && this.isEmptyOrZero(row.decAmount)) {
                    errors.push(`第${index + 1}行：申报申报金额不能为空且不能为0`)
                }
                // 验证 firstNum（如果启用）
                if (!!this.inWarehouseCheckbox[index]?.firstNum && this.isEmptyOrZero(row.firstNum)) {
                    errors.push(`第${index + 1}行：法一数量不能为空且不能为0`)
                }
                // 验证 secondNum（如果启用）
                if (!!this.inWarehouseCheckbox[index]?.secondNum && this.isEmptyOrZero(row.secondNum)) {
                    errors.push(`第${index + 1}行：法二数量不能为空且不能为0`)
                }
            })
            
            return errors
        },
        isEmptyOrZero(value) {
            // 检查是否为空或为0
            return value === '' || value === null || value === undefined || 
                value === 0 || value === '0' || value === 0.0 || 
                (typeof value === 'string' && value.trim() === '')
        },
        // 执行
        async wmsSaveOpTask(){
                var combinationId = this.inWarehouseCheckboxExitRow.map(item => item.id).join(',')
                this.issueGoodsForm.interId = combinationId
                this.issueGoodsForm.createUser = localStorage.getItem('name') // 当前用户名字
                this.issueGoodsForm.handbook = this.warehousingForm.handbook
                this.issueGoodsForm.ckName = this.warehousingForm.ckName
                this.issueGoodsForm.blNo = this.warehousingForm.blNo
                this.issueGoodsForm.cusDeclNo = this.warehousingForm.cusDeclNo
                this.issueGoodsForm.invDecNo = this.warehousingForm.invDecNo
                this.issueGoodsForm.isBonded = this.warehousingForm.isBonded
                // this.issueGoodsForm.boxType = this.warehousingForm.boxType
                // this.issueGoodsForm.boxNum = this.warehousingForm.boxNum
                this.issueGoodsForm.ownerName = this.warehousingForm.ownerName
                this.issueGoodsForm.qty1 = this.inWarehouseCheckboxExitRow.reduce((sum, item) =>  {
                    // 安全地转换为数字
                    const qty = parseFloat(item.qty1);
                    return sum + (isNaN(qty) ? 0 : qty);
                }, 0);
                this.issueGoodsForm.netWeight = this.inWarehouseCheckboxExitRow.reduce((sum, item) => {
                    // 安全地转换为数字
                    const netWeight = parseFloat(item.netWeight);
                    return sum + (isNaN(netWeight) ? 0 : netWeight);
                }, 0) 
                // 货物名称合并去重
                this.issueGoodsForm.goodsName =  [...new Set(this.inWarehouseCheckboxExitRow.map(item => item.goodsName))].join(',')
                // 表体信息，不是硫磺则直接赋值
                if(!this.issueGoodsLOTColumn){
                    this.issueGoodsForm.childList = this.inWarehouseCheckboxExitRow.map(item => {
                        const { id,interId, workedAmount,workedDecNum,workedFirstNum,workedNetWeight,workedQty1,workedQty2,workedSecondNum,workedVol,
                        completeDate,completeTime,createDate,createTime,rowStatus, ...rest } = item;
                        rest.interId = item.id // 组合id
                        // 将仓库,报关单号,核注清单号,客户,货主赋值给rest
                        rest.boxNo = this.issueGoodsForm.boxNo
                        rest.ckName = this.warehousingForm.ckName
                        rest.cusDeclNo = this.warehousingForm.cusDeclNo
                        rest.invDecNo = this.warehousingForm.invDecNo
                        rest.customer = this.warehousingForm.customer
                        rest.ownerName = this.warehousingForm.ownerName
                        rest.handbook = this.warehousingForm.handbook
                        rest.isBonded = this.warehousingForm.isBonded
                        rest.storekeeper = this.issueGoodsForm.storekeeper
                        // 保存计划数值
                        return rest;
                    });
                }else{
                    // 是硫磺则生成lot号条数
                    const LOTarray = this.issueGoodsForm.lotNo.split(/[,\n\r]+/).filter(item => item.trim());
                    const lotQty1 = this.calculateAllPlanFields(this.inWarehouseCheckboxExitRow[0].qty1,LOTarray.length,1)
                    const lotQty2 = this.calculateAllPlanFields(this.inWarehouseCheckboxExitRow[0].qty2,LOTarray.length,1)
                    const lotNetWeight = this.calculateAllPlanFields(this.inWarehouseCheckboxExitRow[0].netWeight,LOTarray.length,1)
                    const lotDecNum = this.calculateAllPlanFields(this.inWarehouseCheckboxExitRow[0].decNum,LOTarray.length,1)
                    const lotDecAmount = this.calculateAllPlanFields(this.inWarehouseCheckboxExitRow[0].decAmount,LOTarray.length,1)
                    const lotFirstNum = this.calculateAllPlanFields(this.inWarehouseCheckboxExitRow[0].firstNum,LOTarray.length,1)
                    const lotSecondNum = this.calculateAllPlanFields(this.inWarehouseCheckboxExitRow[0].secondNum,LOTarray.length,1)
                    const { id,interId, workedAmount,workedDecNum,workedFirstNum,workedNetWeight,workedQty1,workedQty2,workedSecondNum,workedVol,
                        completeDate,completeTime,createDate,createTime,rowStatus, ...baseRow } = this.inWarehouseCheckboxExitRow[0]
                    const newList = Array.from({ length: LOTarray.length }, (_, index) => {
                        // 复制原对象的所有属性，替换字段
                        return {
                            ...baseRow,
                            // 这里换成你自己的新值即可，如果要每条不同，可以根据index动态生成
                            qty1: lotQty1,
                            qty2: lotQty2,
                            netWeight: lotNetWeight,
                            decNum: lotDecNum,
                            decAmount: lotDecAmount,
                            firstNum: lotFirstNum,
                            secondNum: lotSecondNum,
                            lotNo:LOTarray[index],
                            lotKgs:this.issueGoodsForm.lotKgs,
                            lotOrderNo:this.issueGoodsForm.lotOrderNo,
                            lotMaterialNo:this.issueGoodsForm.lotMaterialNo,
                            interId:this.inWarehouseCheckboxExitRow[0].id,
                            boxNo : this.issueGoodsForm.boxNo,
                            ckName : this.warehousingForm.ckName,
                            cusDeclNo: this.warehousingForm.cusDeclNo,
                            invDecNo : this.warehousingForm.invDecNo,
                            customer : this.warehousingForm.customer,
                            ownerName : this.warehousingForm.ownerName,
                            handbook : this.warehousingForm.handbook,
                            isBonded : this.warehousingForm.isBonded,
                            storekeeper : this.issueGoodsForm.storekeeper,
                        }
                    })
                    this.issueGoodsForm.childList = newList
                    // delete this.issueGoodsForm.lotNo
                    // delete this.issueGoodsForm.lotKgs
                    // delete this.issueGoodsForm.lotOrderNo
                    // delete this.issueGoodsForm.lotMaterialNo
                }
                var tempForm = { ...this.issueGoodsForm }
                if(this.issueGoodsLOTColumn){
                    delete tempForm.lotNo
                    delete tempForm.lotKgs
                    delete tempForm.lotOrderNo
                    delete tempForm.lotMaterialNo
                }
                const params = clean(tempForm)
                // const params = clean(this.issueGoodsForm)
                this.$api.wmsSaveOpTask( params ).then(async res =>{
                    // 关闭弹窗
                    await this.IssueGoodsClose()
                    // 重新查询主任务
                    this.getWMSTaskDetail(this.warehousingForm.id)
                    // 查询下发任务列表
                    this.wmsGetOpsBySubId(this.inWarehouseCheckboxExitRow[0].id)
                    // 清空表格选中
                    this.inWarehouseRows = {}
                    this.inWarehouseCheckbox = []
                    this.inWarehouseCheckboxExitRow = []
                    this.$refs.inWarehouseTable.clearCurrentRow();
                })
        },
        // 查询下发任务
        wmsGetOpsBySubId(id){
            this.$api.wmsGetOpsBySubId(id).then(res =>{
                this.IssueGoodsData = res
                this.$refs.IssueGoodsTable.clearCheckboxRow();
                this.selectedDataList = [];
            })
        },
        // 查询所有下发任务
        getIssueAll(){
            this.$api.wmsGetOpsByTaskId(this.warehousingForm.id).then(res =>{
                this.IssueGoodsData = res
                // 货物信息列表取消选中
                // this.$refs.inWarehouseTable.clearRadioRow()
                this.inWarehouseRows = {}
                this.inWarehouseCheckbox = []
                this.$refs.inWarehouseTable.clearCurrentRow();
                this.$refs.inWarehouseTable.clearCheckboxRow();
                this.$refs.IssueGoodsTable.clearCheckboxRow();
                this.selectedDataList = [];
            })

        },
        // 批量填充项号
        fillItemNoAll(){
            // 判断是否多选信息
            if(!this.inWarehouseCheckbox.length){
                this.$message({
                    type: 'warning',
                    message: '请选择计划信息！'
                });
                return false
            }
            this.$prompt('请输入项号', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputPattern: /\S+/, // 正则表达式验证非空
                inputErrorMessage: '项号不能为空',
            }).then(({ value }) => {
                // 获取所有计划信息的id
                const param = this.inWarehouseCheckbox.map(item => item.id)
                this.$api.wmsUpdateItemNo(value,param).then(res =>{
                    this.getWMSTaskDetail(this.warehousingForm.id)

                    this.inWarehouseRows = {}
                    this.inWarehouseCheckbox = []
                    this.$refs.inWarehouseTable.clearCurrentRow();
                    this.$refs.inWarehouseTable.clearCheckboxRow();
                    this.$refs.IssueGoodsTable.clearCheckboxRow();
                    this.selectedDataList = [];
                    this.IssueGoodsData = []
                    // this.IssueGoodsTabs = 'second'
                    // this.getIssueAll()
                })
            }).catch(() => {
               
            });
        },
        // 多选计划信息
        // IssueGoodsCheckboxChange(){
        //     const selectedRecords = this.$refs.IssueGoodsTable.getCheckboxRecords();
        //     this.IssueGoodsRows = selectedRecords;
        //      // 清空选择
        //     // clearSelection() {
        //     // this.$refs.IssueGoodsTable.clearCheckboxRow();
        //     // this.selectedDataList = [];
        //     // }
        // },
        // 下发任务到手持端
        IssueRows(row){
            this.$confirm('是否推送作业任务?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                // 判断是否有子任务
                if(!row.childList || !row.childList.length){
                    this.$message({
                        type: 'warning',
                        message: '没有作业详情，禁止推送!'
                    });
                    return false
                }
                this.$api.wmspushOpTask(row.id).then(res =>{
                    this.$message({
                        type: 'success',
                        message: '推送成功!'
                    });
                    //更新数据
                    this.wmsGetOpsBySubId(row.interId)
                    this.IssueGoodsRows = []
                    this.$refs.IssueGoodsTable.clearCheckboxRow();
                    this.selectedDataList = [];
                })
            }).catch(() => {      
            });
        },
        // 删除作业单
        async delIssueRows(row){
            this.$confirm('是否删除此作业任务?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                // 循环删除行信息
                try {
                    // 删除作业计划
                    this.$api.wmsDeleteJobById(row.id).then(res =>{
                        this.$message({
                            type: 'success',
                            message: '作业任务已删除'
                        });
                        this.wmsGetOpsBySubId(row.interId)
                        this.getWMSTaskDetail(this.warehousingForm.id)
                    })
                } catch (error) {
                    console.error('批量调用接口失败:', error);
                }
                
            })
        },
        // 编辑作业信息，编辑车辆和司机
        exitIssueRows(row){
            this.exitIssueGoodsVisible = true
            this.exitIssueGoodsForm = row
        },
        // 关闭编辑作业信息弹窗
        exitIssueGoodsClose(){
            this.exitIssueGoodsVisible = false
            this.exitIssueGoodsForm = {} 
        },
        // 完成入库打开弹窗
        completeRows(row){
            this.viewCompleteworkVisible = true
            this.completeworkRow =  row
        },
        // 保存编辑下发作业司机车牌
        async saveExitIssueGoods(){
            this.$confirm('是否确定保存编辑信息?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                if(this.exitIssueGoodsForm.driver == '' || this.exitIssueGoodsForm.truckNo == ''){
                    this.$message({
                        type: 'warning',
                        message: '请填写车辆和司机信息！'
                    });
                    return false
                }   
                const params = {
                    driver: this.exitIssueGoodsForm.driver,
                    carNo: this.exitIssueGoodsForm.truckNo,
                }
                try{
                    const id = this.exitIssueGoodsForm.id
                    this.$api.wmsUpdateOpHead( id,params ).then(async res =>{ 
                        this.$message({
                            type: 'success',
                            message: '保存成功！'
                        });
                        // 更新数据
                        await this.wmsGetOpsBySubId(this.exitIssueGoodsForm.interId.split(',')[0].trim())
                        await this.exitIssueGoodsClose()
                    })
                }   catch (err){
                    console.error(err);
                }                
            }).catch(() => { });  
        },
        // 切换作业信息tab，查询详细作业信息列表
        switchIssueGoods(tab, event){
            if(tab.label === '入库详情'){
                this.$api.wmsGetAllJobs(this.warehousingForm.id).then(res =>{
                    this.IssueGoodsAllJob = res
                })
            }
        },
        // 查看完成状态下的作业详情
        getCompleteDetails(row){
            this.viewCompleteworkVisible = true
            this.completeworkRow = row
        },
        // 关闭查看完成状态下的作业详情
        viewCompleteworkClose(id){
            this.viewCompleteworkVisible = false
            this.completeworkRow = {}
            // 刷新页面
            let interId = id;
            if (interId && typeof interId === 'string' && interId.includes(',')) {
                interId = interId.split(',')[0].trim();
            }
            this.wmsGetOpsBySubId(interId)
            this.getWMSTaskDetail(this.warehousingForm.id)
        },
        // 通知父级页面
        notifyParentBeforeUnload(){
            const targetOrigin =  localStorage.getItem('parentOrigin')
            window.opener.postMessage(
                { 
                    type: 'WINDOW_CLOSED',
                    value: true,
                },
                targetOrigin
            );
            // localStorage.clear();
        },
        // 查看上传的所有lot号
        // seacherLotNo(){
        //     this.$api.wmsGetLots(this.warehousingForm.id).then(res =>{
        //         this.lotNoTableListShow = res                
        //     }).catch(error => {
        //         this.$message.error('查询失败');
        //     });
            
        // },
        // 作业信息查看行lot号
        // getIssueGoodsLOT(row){
        //     this.rowLotList = []
        //     this.$api.wmsGetLotsInRkOp(row.id).then(res => {
        //         this.rowLotList = res  || []
        //     })
        // },
        setupMessageListener() {
            // 监听父页面发送的消息
            window.addEventListener('message', (event) => {
                // 验证消息来源（可选，增加安全性）
                if (event.origin !== window.location.origin) {
                // 如果不是同源消息，可以忽略或处理
                }
                if (event.data.type === 'CLOSE_WINDOW_FROM_PARENT') {
                    window.close();
                }
            });
        },
        // 下载lot号模板
        downloadLOTFile(){
            // 构造文件路径
            const fileUrl =  `${process.env.BASE_URL}LOT导入模板.xlsx`
            // 创建一个隐藏的a标签
            const link = document.createElement('a');
            link.href = fileUrl;
            link.download = 'LOT导入模板.xlsx'; // 设置下载后的文件名
            link.style.display = 'none';
            // 将a标签添加到DOM中
            document.body.appendChild(link);
            // 触发点击事件以开始下载
            link.click();
            // 下载完成后移除a标签
            setTimeout(() => document.body.removeChild(link), 100)
        },
        // 打印
        report(command, row){
            // 根据不同的 command 执行不同的打印逻辑
            switch (command) {
                case '入库受理单':
                    this.printAcceptance(row);
                    break;
                case '入库单':
                    this.printInbound();
                    break;
                case '存货凭证':
                    this.printVoucher();
                    break;
                case '存货卡_有标识':
                    this.printCard(row,1);
                    break;
                case '存货卡_无标识':
                    this.printCard(row,0);
                    break;
                case '存货卡_建发':
                    this.printCard(row,2);
                    break;
                case '汇总存货卡_有标识':
                    this.printCardAll(1);
                    break;
                case '汇总存货卡_无标识':
                    this.printCardAll(0);
                    break;
                case '汇总存货卡_建发':
                    this.printCardAll(2);
                    break;
                    
                default:
                    this.$message.warning('未知的打印类型');
            }
           
        },
        // 入库受理单
        async printAcceptance(row){
            // 查询用户电话
            const storekeeperInformation =  await this.$api.getUserInfo( row.storekeeper )
            var tableTask = row.childList.map(item => {
                return {
                    ...item,
                    // completeTime:item.completeTime ? item.completeTime.split('T')[0] : '',
                    placeLocation:item.place + '-' + item.location,
                }
            })
            // 判断数组中的货物名称是否有硫磺，有一个有值就置为true
            //  检查货物名称中是否包含硫磺（如果有需要）
            const hasSulfur = row.childList.some(item => 
                item.goodsName && item.goodsName.includes('硫磺')
            );
            var master = {
                driver:row.driver,
                truckNo:row.truckNo,
                boxNo:row.boxNo,
                sealNo:row.sealNo,
                remark: row.note,
                // lotNoList,
                createUser:this.warehousingForm.createUser,
                storekeeper:row.storekeeper,
                storekeeperPhone:storekeeperInformation.phone,
                LOTShow:hasSulfur,
                taskNote:row.taskNote,
            }
            const params = { master:master,table:tableTask }
            var args = {
                report: urlAddRandomNo("/grf/入库受理单.grf"),
                data: params,
                type: "preview",
            };
            webapp_ws_ajax_run(args);
        },
        // 入库单
        async printInbound(){
            var goodsAllJob = []
            // 查询所有作业信息
            await this.$api.wmsGetInStockSumById(this.warehousingForm.id).then(res =>{
                goodsAllJob = res.map(item => {
                    return {
                        goodsName:item.goodsName,
                        spec:item.spec,
                        qty1:item.totalQty1,
                        netWeight:item.totalNetWeight,
                        qtyUnitName:this.findNameByCode(item.qty1Unit, this.unitList),
                        blNo:this.warehousingForm.blNo,
                        // completeTime:item.completeDate,
                        cusDeclNo:this.warehousingForm.cusDeclNo,
                    }
                })
            })
            // 打印两张入库单，一张有备注一张没备注
            const mergedParams = [
                // 把两个主单信息封装成数组，模板里对应分页
                {
                    report: urlAddRandomNo("/grf/入库单.grf"),
                    data: {
                        master: [{
                            ownerName:this.warehousingForm.ownerName,
                            createUser:this.warehousingForm.createUser,
                            ckAddress:(this.warehousingForm.ckName === '纽约路仓库' || this.warehousingForm.ckName === '外协库') ? '青岛保税港区纽约路2号' : '青岛市黄岛区富源工业园七星河路363号',
                            note:this.warehousingForm.remark,
                        }],
                        table:goodsAllJob
                    }
                },{
                    report: urlAddRandomNo("/grf/入库单.grf"),
                    data: {
                        master: [{
                            ownerName:this.warehousingForm.ownerName,
                            createUser:this.warehousingForm.createUser,
                            ckAddress:(this.warehousingForm.ckName === '纽约路仓库' || this.warehousingForm.ckName === '外协库' )? '青岛保税港区纽约路2号' : '青岛市黄岛区富源工业园七星河路363号',
                            note:''
                        }],
                        table:goodsAllJob
                    }
                }
                
            ]
            const args = {
                type: "preview", // 或 "print"
                FontEmbedding: true
            };
            webapp_ws_ajax_together(args, mergedParams);
        },
        // 生成凭证号，唯一性
        getVoucherNo(){
            const year = new Date().getFullYear();
            const timestamp = Date.now();
            // 取时间戳的最后4位
            const uniqueNum = (timestamp % 10000).toString().padStart(4, '0');
            return `No.FEST-${year}-${uniqueNum}`;
        },
        // 存货凭证
        async printVoucher(){
            const reports = []
            const headTextList = [
                {
                    headText:'第一联  仅供货主留存'
                },{
                    headText:'第二联  仅供银行对外付汇留存'
                },
            ]
            // 查询仓库信息
            const ckInformation = await this.$api.getWmsCkInfo(this.warehousingForm.ckName)
            // 1. 构造报表数组
            headTextList.forEach(item => {
                const singleData = {
                    master: [{
                        no:this.getVoucherNo(),
                        headText:item.headText,
                        ownerName: this.warehousingForm.ownerName,
                        blNo:this.warehousingForm.blNo,
                        cusDeclNo:this.warehousingForm.cusDeclNo,
                        goodsName: this.inWarehouseData[0].goodsName,
                        spec: this.inWarehouseData[0].spec,
                        netWeight:this.warehousingForm.netWeight/1000,
                        qty1Sum:this.warehousingForm.qty1Sum,
                        ckName: '青岛菲尔斯特物流有限公司',
                        address:ckInformation[0].address,
                        ckPerson:ckInformation[0].contractMan,
                        ckPhone:this.warehousingForm.ckName === '纽约路仓库' ? '0532-86760176' : '0532-86760189',
                        ckFax:'0532-86760266',
                        email:ckInformation[0].email,
                    }],
                };
                reports.push({
                    report: urlAddRandomNo("/grf/存货凭证.grf"), // 模板路径或JSON
                    data: singleData // 对应的数据
                });
            });
            // 2. 主参数 args
            const args = {
                type: "preview", // 或 "print"
                FontEmbedding: true
            };
            // 3. 调用 together 方法
            webapp_ws_ajax_together(args, reports);
        },
        // 存货卡
        async printCard(row,logo){
            // 判断是否保税
            var reportURL = ''
            if(logo === 1){
                if(this.warehousingForm.isBonded === '保税'){
                    reportURL = '/grf/存货卡_有标识.grf'
                }else{
                    reportURL = '/grf/存货卡_非保有标识.grf'
                }
            }else if(logo === 0){
                if(this.warehousingForm.isBonded === '保税' ){
                    reportURL = '/grf/存货卡_无标识.grf'
                }else{
                    reportURL = '/grf/存货卡_非保无标识.grf'
                }
            }else if(logo === 2){
                reportURL = '/grf/存货卡_建发.grf'
            }

            const reports = []
            // 1. 构造报表数组
            row.childList.forEach( item => {
                const singleData = {
                    master: [{
                        goodsName: item.goodsName,
                        spec: item.spec,
                        completeTime: row.completeTime ? row.completeTime.split('T')[0] : '',
                        location: item.location,
                        place: item.place,
                        ckName: item.ckName,
                        ownerName: this.warehousingForm.ownerName,
                        invDecNo:this.warehousingForm.invDecNo,
                        qty1: item.qty1,
                        qty1UnitName: this.findNameByCode(item.qty1Unit, this.unitList),
                        qty2:item.qty2 ? '/' + item.qty2 : '' ,
                        qty2UnitName: this.findNameByCode(item.qty2Unit, this.unitList),
                        blNo: item.blNo,
                        remark: this.warehousingForm.remark ?  this.warehousingForm.remark :'' + row.note ? row.note : '',
                        // remark: this.warehousingForm.remark,
                        boxNo:item.boxNo,
                        truckNo:item.truckNo,
                        cusDeclNo:this.warehousingForm.cusDeclNo,
                        itemNo:item.itemNo,
                    }],
                };
                reports.push({
                    report: urlAddRandomNo(reportURL), // 模板路径或JSON
                    data: singleData // 对应的数据
                });
            });
            var args = {
                FontEmbedding: true,
                type: "preview",
            };
            // 3. 调用 together 方法
            webapp_ws_ajax_together(args, reports);
        },
        // 汇总货卡
        async printCardAll(logo){
            // 查询数据
            var reportURL = ''
            if(logo === 1){
                if(this.warehousingForm.isBonded === '保税'){
                    reportURL = '/grf/存货卡_有标识.grf'
                }else{
                    reportURL = '/grf/存货卡_非保有标识.grf'
                }
            }else if(logo === 0){
                if(this.warehousingForm.isBonded === '保税'){
                    reportURL = '/grf/存货卡_无标识.grf'
                }else{
                    reportURL = '/grf/存货卡_非保无标识.grf'
                }
            }else if(logo === 2){
                reportURL = '/grf/存货卡_建发.grf'
            }
            var reports = []
            await this.$api.wmsGetSummaryStockCard(this.warehousingForm.id).then(res => {
                res.forEach( item => {
                    const singleData = {
                        master: [{
                            goodsName: item.goodsName,
                            spec: item.spec,
                            completeTime: item.createDate ? item.createDate : '',
                            location: item.location,
                            place: item.place,
                            ckName: item.ckName,
                            ownerName: this.warehousingForm.ownerName,
                            invDecNo:this.warehousingForm.invDecNo,
                            qty1: item.totalQty1,
                            qty1UnitName: this.findNameByCode(item.qty1Unit, this.unitList),
                            qty2:item.totalQty2 ? '/' + item.totalQty2 : '' ,
                            qty2UnitName: this.findNameByCode(item.qty2Unit, this.unitList),
                            blNo: this.warehousingForm.blNo,
                            remark: this.warehousingForm.remark ?  this.warehousingForm.remark :'',
                            // remark: this.warehousingForm.remark,
                            boxNo: item.goodsName ? (item.goodsName.includes('硫磺') ? item.boxNo : '') : '',
                            // truckNo:item.truckNo,
                            cusDeclNo:this.warehousingForm.cusDeclNo,
                            itemNo:item.itemNo,
                            // lotList:'123123132',
                            lotMaterialNo: item.lots ? item.lots[0].lotMaterialNo : '',
                            lotOrderNo: item.lots ? item.lots[0].lotOrderNo : '',
                            lotList: item.lots ? item.lots.map((lot, index) => {
                                const number = (index + 1).toString().padStart(2, ' '); // 2位宽，不足用空格填充
                                return `${number}   ${lot.lotNo}  件数：${lot.qty1}   重量：${lot.lotKgs}   `;
                                // return `${number}   ${lot.lotNo}  件数：${lot.qty1}   重量：${lot.lotKgs}   物料号：${lot.lotMaterialNo}   订单号： ${lot.lotOrderNo}   `;
                            }).join('\n') : '',
                        }],
                    };
                    reports.push({
                        report: urlAddRandomNo(reportURL), // 模板路径或JSON
                        data: singleData // 对应的数据
                    });
                });
            })
            
            // 2. 主参数 args
            var args = {
                type: "preview", // 或 "print"
                FontEmbedding: true
            };
            // 3. 调用 together 方法
            webapp_ws_ajax_together(args, reports);
            
        },
        // 完成任务，任务完成后不允许修改
        completeTask(){
            this.$confirm('是否确定结束任务?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                // 结束接口
                this.$api.wmsFinishTask(this.warehousingForm.id).then(res =>{
                    this.$message({
                        type: 'success',
                        message: '任务结束成功!'
                    });
                    // 刷新页面
                    this.getWMSTaskDetail(this.warehousingForm.id)
                    // 清空数据
                    this.IssueGoodsData = []
                    this.IssueGoodsTabs = 'first' 
                })
            }).catch(() => {
                
            });
        },
        // 撤销任务结束
        revokeCompleteTask(){
            this.$confirm('是否确定撤销结束?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                // 撤销接口
                this.$api.wmsUnDoTask(this.warehousingForm.id).then(res =>{
                    this.$message({
                        type: 'success',
                        message: '任务撤销成功!'
                    })
                     // 刷新页面
                    this.getWMSTaskDetail(this.warehousingForm.id)
                    // 清空数据
                    this.IssueGoodsData = []
                    this.IssueGoodsTabs = 'first' 
                })
            })
        },
        // 上传图片导出
        async IMGListExport(){
            try {
                const res = await this.$api.wmsDownloadFiles(this.warehousingForm.id)
                // 下载成功逻辑
            } catch (error) {
                console.log('下载失败，但不显示提示', error)
            } finally {
                // 成功/失败都会执行这里
                const downloadURL = await this.$api.wmsGetTaskZipFile(this.warehousingForm.id)
                const a = document.createElement('a')
                a.href = downloadURL
                // 可选：指定下载文件名
                // a.download = this.warehousingForm.blNo +  '.zip'
                document.body.appendChild(a)
                a.click()
                document.body.removeChild(a)
            }     
        },
    },
    beforeDestroy() {
        window.removeEventListener('beforeunload', this.notifyParentBeforeUnload)
    }
}
</script>
<style lang="less" scoped>
.width_100{
    width: 100%;
}
.margin_right_20{
    margin-right: 20px;
}
.warehousingForm{
    margin: 10px;
}
.mini_button{
    padding: 3px 8px !important;
}
.mini_button_text{
    padding: 3px 3px !important;

}
// 表头样式
.warehousingForm .el-col-4{
    padding-left: 8px !important;
    padding-right: 8px !important;
}
.warehousingForm .el-form-item--mini.el-form-item, .el-form-item--small.el-form-item{
    // margin-bottom: 3px !important;
    margin-right: 5px !important;
}
.el-form-item__content{
    width: 100% !important;
}
.el-form-item__label{
    color: black;
}
// 分割线颜色
.el-divider__text{
    color: #797c81 !important;
}
.el-divider--horizontal {
    margin: 10px 0;
}
// 按钮
.buttons_box{
    margin: 5px 15px;
    display: flex;
    align-items: center;
}
// 表格按钮样式
.vxe-toolbar{
    padding: 0px;
}
// 控制弹窗表单高度
.goods_form  {
  max-height: 62vh;
  /* 垂直方向超出滚动，水平方向隐藏 */
  overflow-y: auto;
  overflow-x: hidden;
  box-sizing: border-box; /* 内边距计入高度，避免高度溢出 */
}
.tipText{
    font-size: 12px;
    font-weight: bold;
    margin-left: 5px;
}
.form_item_60{
    width: 60%;
}
.el-button+.el-button, .el-checkbox.is-bordered+.el-checkbox.is-bordered {
    margin-left: 5px;
}
.IssueGoodsExitRow{
    display: flex;
    justify-content:space-between;
    flex-direction: column;
}
.IssueGoodsExitRow_flex{
    display: flex;
}
.IssueGoodsTipText{
    width: 100%;
    font-weight: bold;
    margin: 0px 5px;
    text-align: right;
    font-size: 10px;
}
.finish_upload{
    margin: 5px 0px;
    font-size: 14px;
    font-weight: bold;
    width:50%

}

::v-deep .finishIssueGood_dialog .el-dialog .el-dialog__body{
     height: 500px !important;
     overflow-y: auto !important;
}
::v-deep .el-upload--picture-card{
    width:100px !important;
    height:100px !important;
    line-height: 100px !important;
}
::v-deep .el-upload-list--picture-card .el-upload-list__item{
    width:100px !important;
    height:100px !important;
    line-height: 100px !important;
}
</style>